import { Component, ViewChild, TemplateRef, ElementRef, Renderer2, OnInit, ViewEncapsulation, Input, EventEmitter, Output, AfterViewInit, OnDestroy } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AppService } from '../../app.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from '../../support/success-snackbar/success-snackbar.component';
import { PaginationService } from '../../PaginationService';
import { messageService } from '../../message.service';
import { MatOption } from '@angular/material/core';
import { qmsService } from '../qms.service';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { AuFindingsComponent } from '../../qms/au/au-findings/au-findings.component';
import { TopNavigationComponent } from 'src/app/top-navigation/top-navigation.component';
import { ActivityAuTrailComponent } from 'src/app/qms/activity-au-trail/activity-au-trail.component';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { EditorComponent } from 'src/app/editor/editor.component';
import { MatSelect } from '@angular/material/select';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { DependencyNavigationService } from 'src/app/support/navigation/dependency-navigation.service';
import * as moment from 'moment-timezone';
import { forkJoin, Observable, switchMap } from 'rxjs';
import { FlexibleFieldsComponent } from '../flexible-fields/flexible-fields.component';

@Component({
  selector: 'app-activity-grid',
  templateUrl: './activity-grid.component.html',
  styleUrls: ['./activity-grid.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class ActivityGridComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('flexible', { static: false }) flexibleComponent!: FlexibleFieldsComponent;
  @ViewChild(TopNavigationComponent) topNavigationComponent!: TopNavigationComponent;

  snackbarRef: any;
  dateCustomClasses: DatepickerDateCustomClasses[];
  infoIconSrc: string = '../../assets/img/info-yellow.png';
  filterList: any;
  hightSection: any;

  constructor(
    private readonly appService: AppService,
    private readonly snackBar: MatSnackBar,
    private readonly elem: ElementRef,
    private readonly activatedRoute: ActivatedRoute,
    private readonly renderer: Renderer2,
    private readonly dependencyNavigationService: DependencyNavigationService,

    readonly dialog: MatDialog,
    readonly router: Router,
    readonly paginationService: PaginationService,
    readonly message: messageService,
    readonly qualityService: qmsService,
    readonly auFindingsComponent: AuFindingsComponent,
  ) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
    this.activatedRoute.params.subscribe(params => { this.main(params['name']); });
    this.selectedGroupValue = this.qualityService.SelectedGroupNameAndValue;
  };

  private clickListener: () => void;
  private boundKeyDown = this.onKeyDown.bind(this);
  private boundKeyUp = this.onKeyUp.bind(this);
  private boundReset = this.resetKeyState.bind(this);

  ngOnInit(): void {
    document.addEventListener('keydown', this.boundKeyDown);
    document.addEventListener('keyup', this.boundKeyUp);
    window.addEventListener('blur', this.boundReset);
    document.addEventListener('contextmenu', this.boundReset);

    this.qualityService.activity = {};
    this.reportFooterDropdown = [];
    this.ngOnChangesReport();
    this.ngOnChangesReportFooter();

    if (this.message.breadcrumbData.thirdLevel != null) {
      if (this.message.breadcrumbData.thirdLevel.includes("(")) {
        let thirdLevel = this.message.breadcrumbData.thirdLevel.split("(");
        this.message.breadcrumbData.thirdLevel = thirdLevel[0];
      }
    }
  }

  public reloadCurrentRoute(): void {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/dashboard/ActivityCR/', { skipLocationChange: true }).then(() => { this.router.navigate([currentUrl]) });
  }

  dvCriticalityList: any = [];
  dvCriticalityDropdown: any = [];

  private main(value: any): void {

    this.qualityService.moduleName = value;
    this.PageName = this.qualityService.activityTitle;

    this.oosMenuType.push(this.qualityService.moduleName == 'OOS' ? 'OOS' : [])
    this.dropDownForOosType = JSON.parse(sessionStorage.getItem('dropDownForOosType') || '{}');
    this.dropDownForDepartmentCode = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') || '{}');
    this.dropDownForDesignationCode = JSON.parse(sessionStorage.getItem('dropDownForDesignationCode') || '{}');


    const groupId = this.qualityService.SelectedGroupNameAndValue[0].valueExp;
    const obj = { module: this.qualityService.moduleName, groupId };
    const $requests: Observable<any>[] = [];

    $requests.push(
      this.appService.getgridfilters(this.qualityService.moduleName),
      this.appService.getGridChartCountsDetails(obj),
      this.appService.getGroupsModuleCurrentUserVw(this.qualityService.moduleName),
      this.appService.getAllQmsBusinessAreas(),
      this.appService.getCodeListsByGroup("DEVIATION_CRITICALITY")
    );

    forkJoin($requests).subscribe(([filters, charts, group, requestedAt, dvCriticality]) => {

      this.filterList = filters;
      this.generateChart(charts);

      this.groupList = group;
      this.setGroup();

      this.getQmsBusinessAreaDetail = requestedAt;
      this.selectBoxeForRequestedAt();
      this.selectBoxForDvRequestedAt();
      this.selectBoxForCapaRequestedAt();
      this.selectBoxForQiRequestedAt();
      this.setReason();

      this.selectBoxForGroup();
      this.selectBoxeForDepartmentCode();
      this.selectBoxeForDesignationCode();
      this.selectBoxForCapaDepartmentCode();
      this.selectBoxForDvDepartmentCode();
      this.selectBoxForQiDepartmentCode();
      this.qualityService.moduleName == 'QI' && this.generateQiDropdownValues();
      this.selectBoxForOosType();

      this.dvCriticalityList = dvCriticality;
      this.selectBoxForDvCriticality();
    });
  }

  totalNumberOfData: any = [];
  charts: any = [];
  generateChart(chartData: any) {

    const keys = Object.keys(chartData[0]);

    const statusMapping: {
      [key: string]: { id: number; status: string; colorCode: string; }
    } = {
      total: { id: 1, status: 'Total', colorCode: '#0080FF' },
      closed: { id: 2, status: 'Closed', colorCode: '#009C40' },
      active: { id: 3, status: 'Active', colorCode: '#ECFF00' },
      others: { id: 4, status: 'Others', colorCode: '#9D97FF' },
      overdue: { id: 5, status: 'Overdue', colorCode: '#FF0000' },
      myTotal: { id: 6, status: 'My Total', colorCode: '#FF00FB' },
      myActive: { id: 7, status: 'My Active', colorCode: '#FF00FB' },
      myOverdue: { id: 8, status: 'My Overdue', colorCode: '#FF00FB' }
    };

    this.charts = [];

    for (const key of keys) {
      if (statusMapping[key]) {
        this.charts.push({
          ...(statusMapping[key] as { id: number; status: string; colorCode: string }),
          count: chartData[0][key] ?? 0,
        });
      }
    }

    this.totalNumberOfData = this.charts.filter((x: any) => x.status === 'Total');
    for (const item of this.charts) {
      if (item.status !== 'Total') {
        if (item.count && item.count > 0 && this.totalNumberOfData[0]?.count && this.totalNumberOfData[0].count > 0) {
          item.percentage = Math.round((item.count / this.totalNumberOfData[0].count) * 100);
        } else {
          item.percentage = 0;
        }
      }
      if (!item.count) {
        item.count = 0;
      }
    }

    this.charts.sort((a: any, b: any) => a.id - b.id);
    this.preIdAttribute = '';
    const getInitialActiveValue = this.charts.find((x: any) => x.status === 'Active');
    this.qualityService.activity.chartStatus = getInitialActiveValue.status;
    this.onChartClick(getInitialActiveValue.id, getInitialActiveValue, "Manually");
  }

  currentIdAttribute: any;
  preIdAttribute: any = '';
  styleMiniChartContainer: any;
  onChartClick(event: any, data: any, from: any) {
    if (from == "Manually") {
      this.chartFilter = { filterCondition: "", filterName: "None", filterSeq: 0, isActive: "", pageName: "", serviceRequestReference: "", usedAsAppend: "" };
    }

    if (this.preIdAttribute != '') {
      this.styleMiniChartContainer = document.getElementById(this.preIdAttribute) as HTMLInputElement;
      this.styleMiniChartContainer.style.boxShadow = '';
    }

    if (event.currentTarget) {
      this.currentIdAttribute = event.currentTarget.id;
      this.preIdAttribute = event.currentTarget.id;
      this.qualityService.activity.chartStatus = data.status;
    } else {
      this.currentIdAttribute = "" + event + "";
      this.preIdAttribute = "" + event + "";
    }

    this.styleMiniChartContainer = document.getElementById(this.currentIdAttribute) as HTMLInputElement;
    this.hightSection = data.status;
    this.getCall();
  }

  public chartFilter = { filterCondition: "", filterName: "None", filterSeq: 0, isActive: "", pageName: "", serviceRequestReference: "", usedAsAppend: "" };

  public additionalFilter(item: any): void {

    if (item == null) {
      this.chartFilter = {
        filterCondition: "",
        filterName: "None",
        filterSeq: 0,
        isActive: "",
        pageName: "",
        serviceRequestReference: "",
        usedAsAppend: ""
      };
      this.getCall();
    } else {
      this.chartFilter = item;

      if (this.chartFilter.usedAsAppend == "N") {
        this.preIdAttribute = '';
        const getInitialActiveValue = this.charts.find((x: any) => x.status === 'Total');
        this.qualityService.activity.chartStatus = getInitialActiveValue.status;
        this.onChartClick(getInitialActiveValue.id, getInitialActiveValue, "Filter");
      } else {
        this.getCall();
      }
    }
  }

  private setGroup() {
    if (this.groupList.length) {
      if (this.qualityService.SelectedGroupNameAndValue.length > 0) {
        this.selectedGroupValue = [];
        this.selectedGroupValue = this.qualityService.SelectedGroupNameAndValue;
        this.onGroupSelect(this.selectedGroupValue[0]);
      } else if (this.groupList.length == 1 && this.qualityService.SelectedGroupNameAndValue.length == 0) {
        this.selectedGroupValue = [{ valueExp: this.groupList[0].groupId, displayExp: this.groupList[0].groupName }];
        this.onGroupSelect(this.selectedGroupValue[0]);
      } else {
        this.selectedGroupValue = [];
      }
      this.selectBoxForGroup();
    } else if (this.message.breadcrumbData.thirdLevel != null && this.qualityService.moduleName != undefined) {
      this.isProcessing = false;
      alert("Group not added");
    }
  }

  private selectBoxForGroup() {
    this.groupValueDropdown = this.groupList?.map((group: any) => ({
      valueExp: group?.groupId,
      displayExp: group?.groupName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  public onGroupSelect(item: any): void {
    const { valueExp } = item;

    const module = this.qualityService.moduleName;

    this.selectedGroupValueValueExp = valueExp;
    this.qualityService.selectedActivityGroupId = valueExp;
    this.setGroupDetails(valueExp);

    forkJoin({
      roles: this.appService.getQmsActiveUserByGroupIdModuleUserId(valueExp, module) as Observable<any[]>,
      owners: this.appService.getQmsActiveGroupUsers(valueExp, module, 'Owner'),
      evaluators: this.appService.getQmsActiveGroupUsers(valueExp, module, 'Evaluator')
    }).subscribe({
      next: ({ roles, owners, evaluators }) => {
        const userRoles = roles[0]?.qmsRoles || [];

        this.qualityService.userRole = roles;
        this.isInitiator = this.qualityService.loggedInitiaor = userRoles.includes('Initiator');
        this.qualityService.loggedQa = userRoles.includes('QA');

        this.listOfOwnerUsers = owners;
        this.callOwnersListSelectBoxValues();
        this.selectBoxForCapaOwnerList();
        this.selectBoxForDvOwnersList();

        this.dropDownForQiEvaluator = evaluators;
        this.selectBoxForEvaluator();
      },
      error: err => {
        this.isProcessing = false;
        this.showSnackBar(err, 'E');
      }
    });
  }

  private setGroupDetails(groupId: any): void {


    this.appService.getQmsGroupDetailsByModule(groupId, this.qualityService.moduleName).subscribe((data: any) => {

      this.detailsId = data.groupDetailId;
      this.qualityService.selectedGroupDetailData = data;
      this.qualityService.selectedGroupDetailId = this.detailsId;
      const x = data.masterpageDashboard;

      if (x) {
        this.showMyTask = x.includes('My Task');
        this.showAllTask = x.includes('All');
        this.showMyFilter = x.includes('Filter');
      } else {
        this.showMyTask = this.showAllTask = this.showMyFilter = true;
      }

      const allCharts = [...this.charts];
      let removeStatuses: string[] = [];

      if (this.showMyTask && !this.showAllTask) {
        removeStatuses = ['Others', 'Overdue']
      } else if (this.showAllTask && !this.showMyTask) {
        removeStatuses = ['My Overdue', 'My Active', 'My Total'];
      } else if (!this.showMyTask && !this.showAllTask) {
        removeStatuses = ['My Overdue', 'My Active', 'My Total', 'Others', 'Overdue'];
      }

      this.charts = allCharts.filter((chart: any) => !removeStatuses.includes(chart.status));

      this.appService.getTypeSettingsByGrpIdGrpDetailId(groupId, this.detailsId).subscribe((response: any) => {
        this.dropDownForChangeType = response;
        if (response?.length) {
          this.selectBoxeForchangeType();
          this.selectBoxForCapaType();
          this.selectBoxForDeviationType();
          this.selectBoxForQiType();
        }
      });
    });
  }


  dateFormat: any = this.message.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';

  datePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }

  dateTimePickerConfiguration = {
    dateInputFormat: 'DD-MMM-YYYY HH:mm:ss',
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  }

  openGroupMethod() {
    this.topNavigationComponent.opengroupPopup();
  }

  selectedReportFooter: any;
  reportFooterDropdown1: any = [];
  reportFooterDropdown: any = [];
  oosTypeDropdown: any = [];
  dropDownForOosType: any = [];
  selectedOosType: null;
  dropDownForCoreBusinessAreaName: any = [];
  getQmsBusinessAreaDetail: any = [];
  getReasonForChangeListValues: any = [];
  getQmsGroupUserslist: any = [];
  filteredDataForEvaluator: any = [];
  reasonForChangeValue: any = [];
  reasonForChangeDropdown: any = [];
  selectedDepartmentValueExp: any;
  criticalitySearchText: string = '';

  private setReason() {

    const moduleReasonMap: any = { CR: 'REASON_FOR_CHANGE', CAPA: 'REASON_FOR_CAPA', DV: 'REASON_FOR_DEVIATION' };
    const moduleActionMap: any = { CR: () => this.setCrReason(), CAPA: () => this.setCapaReason(), DV: () => this.setDvReason() };
    const moduleName = this.qualityService.moduleName;
    const reason = moduleReasonMap[moduleName];

    if (reason) {
      this.appService.getCodeListsByGroup(reason).subscribe((values: any) => {
        this.getReasonForChangeListValues = values;
        moduleActionMap[moduleName]?.();
      });
    }
  }

  selectBoxForOosType() {
    this.oosTypeDropdown = this.dropDownForOosType.map((oosType: any) => ({
      valueExp: oosType.codelistCode,
      displayExp: oosType.codelistName
    }))
  }

  selectBoxForDvCriticality() {
    this.dvCriticalityDropdown = this.dvCriticalityList.map((dv: any) => ({
      valueExp: dv.codelistCode,
      displayExp: dv.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []
  }

  onDeviationCriticalitySelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('dv-criticality', item);
    }
  }

  generateQiDropdownValues() {
    this.appService.getCodeListsByGroup("QUALITY_ISSUE_REFERENCE").subscribe((referenceData: any) => {
      this.dropDownForQiReference = referenceData;
      this.selectBoxForQiReference();
    })

    this.appService.getCodeListsByGroup("QI_IMPACT_TYPE").subscribe((impactTypeData: any) => {
      this.dropDownForQiImpactType = impactTypeData;
      this.selectBoxForQiImpactType();
    })
  }


  selectBoxeForDepartmentCode() {
    this.departmentCodeDropdown = [];
    for (const element of this.dropDownForDepartmentCode) {
      this.departmentCodeDropdown = this.departmentCodeDropdown.concat({
        valueExp: element.codelistCode,
        displayExp: element.codelistName
      });
    }
  }

  onDepartmentSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectedDepartmentValueExp = item.valueExp;
        if (this.departmentFieldValue != undefined) {
          this.departmentFieldValue.style.color = '#005c8a';
        }
      } else {
        this.selectedDepartmentValueExp = undefined;
        if (this.departmentFieldValue != undefined) {
          this.departmentFieldValue.style.color = 'red';
        }
      }
    }
  }

  selectedinitialDepartmentValueExp: any;
  oninitialDepartmentSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectedinitialDepartmentValueExp = item.valueExp;
        if (this.departmentFieldValue != undefined) {
          this.departmentFieldValue.style.color = '#005c8a';
        }
      } else {
        this.selectedinitialDepartmentValueExp = undefined;
        if (this.departmentFieldValue != undefined) {
          this.departmentFieldValue.style.color = 'red';
        }
      }
    }
  }

  selectBoxeForchangeType() {
    this.changeTypeDropdown = [];
    this.changeTypeDropdown = this.dropDownForChangeType?.map((item: any) => ({
      valueExp: item.type,
      displayExp: item.type
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) || []
  }

  selectChangeTypeCodeValueExp: any;
  onchangeTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.isProcessing = true;
        this.expectedToBeStartedOnFieldValue = document.getElementById('expectedToBeStartedOn-validation') as HTMLInputElement;
        this.expcetedClosureOnFieldValue = document.getElementById('expcetedClosureOn-validation') as HTMLInputElement;
        this.selectChangeTypeCodeValueExp = item.valueExp;
        if (item.valueExp == 'NA') {
          this.showChangeTypeIfNa = true;
        } else {
          this.showChangeTypeIfNa = false;
          this.appService.getTypeSettingsByType(this.selectedGroupValue[0].valueExp, this.detailsId, item.valueExp).subscribe((response: any) => {
            if (response != null) {
              if (response.toBeStartedInDays) {
                let date = new Date();
                date.setDate(date.getDate() + response.toBeStartedInDays);
                this.qmsCRData.expectedToBeStartedOn = date;
                this.expectedToBeStartedOnFieldValue.style.color = '#005c8a';
              } else {
                this.qmsCRData.expectedToBeStartedOn = null;
              }

              if (response.toBeClosedInDays) {
                let date = new Date();
                this.qmsCRData.expectedToBeStartedOn == null ? date.setDate(date.getDate() + response.toBeClosedInDays) : date.setDate(date.getDate() + response.toBeStartedInDays + response.toBeClosedInDays);
                this.qmsCRData.expcetedClosureOn = date;
                this.expcetedClosureOnFieldValue.style.color = '#005c8a';
              } else {
                this.qmsCRData.expcetedClosureOn = null;
              }
            }
            this.isProcessing = false;
          })
        }

      } else {
        this.showChangeTypeIfNa = false;
      }
    }
  }

  ngOnChangesReport() {
    this.qualityService.refereshBreadCrumb = true;
    this.message.breadcrumbData.thirdLevel = "";
    this.isProcessing = true;



    this.appService.getOneQmsOrganizationReportImage().pipe(switchMap((data: any) => {
      this.organizationReportImageDetails = data;
      return this.appService.getQmsReportLogoByModuleAndGroupId("QMS", this.qualityService.SelectedGroupNameAndValue[0].valueExp)
    })).subscribe({
      next: (data: any) => {
        this.dropDownDataForReportLogo = data;
        this.selectBoxForReportLogo();
        this.isProcessing = false;
      },
      error: () => {
        this.isProcessing = false;
      }
    });
  }

  listOfUsers: any = [];
  listOfOwnerUsers: any = [];

  isProcessing: boolean = false;
  PageName: any;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  searchValue: any;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  pager: any = {};

  pagedItems: any[];
  error = '';
  makeStickyColumns: any;
  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  CRList: any = [];

  designationCodeValue: any;
  departmentCodeValue: any;
  statusCodeValue: any;
  columnLists: any = {};
  dataTypeList: any = [];
  array: any = [];
  visibleEditButton: boolean;
  dropDownForModules: any;
  popupTitle: any;
  groupValueDropdown: any = [];
  groupList: any = [];
  selectedGroupValue: any = [];

  departmentCode: any = [];
  changeTypeValue: any = [];
  departmentCodeDropdown: any = [];
  dropDownForDepartmentCode: any;
  dropDownForChangeType: any;
  changeTypeDropdown: any = [];
  showChangeTypeIfNa: any = false;
  RequestedAtDropdown: any = [];
  dropDownForRequestedAt: any = [];
  requestedAtValue: any = [];
  coreBusinessAreaNameDropdown: any = [];
  coreBusinessAreaNameValue: any = [];
  detailsId: any = null;
  showMyTask: any = false;
  showAllTask: any = false;
  showMyFilter: any = false;

  isInitiator: boolean;
  selectedGroupValueValueExp: any;
  filteredRequestedAtValue: any = [];
  selectBoxeForRequestedAt() {
    this.RequestedAtDropdown = [];
    this.filteredRequestedAtValue = this.getQmsBusinessAreaDetail.filter((x: any) => x.module === this.message.changeRequestCode);
    for (const element of this.filteredRequestedAtValue) {
      this.RequestedAtDropdown = this.RequestedAtDropdown.concat({
        valueExp: element.taskRequestedAt,
        displayExp: element.taskRequestedAt
      });
    }
  }

  bussinessAreaName: any;
  filteredBusinessAreaValue: any = [];
  onRequestedAtSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {

        this.coreBusinessAreaNameDropdown = [];
        this.coreBusinessAreaNameValue = [];

        this.bussinessAreaName = item.displayExp;
        item.taskSeq = 0;
        let businessAreaValues = this.filteredRequestedAtValue.filter((x: any) => x.taskRequestedAt === item.displayExp);
        if (businessAreaValues.length != 0) {
          this.filteredBusinessAreaValue = businessAreaValues[0].listOfBusinessArea?.split(',');
          this.selectBoxForCoreBusinessAreaName();
        }

        if (this.requestedAtFieldValue != undefined) {
          this.requestedAtFieldValue.style.color = '#005c8a';
        }

      } else {
        this.bussinessAreaName = undefined;
        if (this.requestedAtFieldValue != undefined) {
          this.requestedAtFieldValue.style.color = 'red';
        }

        if (this.requestedAtValue.length == 0) {
          this.coreBusinessAreaNameValue = [];
          this.coreBusinessAreaNameDropdown = [];
          this.bussinessAreaName = undefined;
        }
      }
      setTimeout(() => { this.flexibleComponent.triggerFromRequestedAt(item.valueExp) })
    }
  }

  selectBoxForCoreBusinessAreaName() {
    this.coreBusinessAreaNameDropdown = [];
    for (let i = 0; i < this.filteredBusinessAreaValue?.length; i++) {
      this.coreBusinessAreaNameDropdown = this.coreBusinessAreaNameDropdown.concat({
        valueExp: this.filteredBusinessAreaValue[i],
        displayExp: this.filteredBusinessAreaValue[i]
      });
    }
  }

  selectCoreBusinessAreaNameValueExp: any = [];
  onCoreBusinessAreaNameSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectCoreBusinessAreaNameValueExp = item.valueExp;
        setTimeout(() => {
          this.allcoreBusinesssSelected = this.coreBusinessAreaNameDropdown.length == this.coreBusinessAreaNameValue.length;
        });
        if (this.coreBusinessAreaFieldValue != undefined) {
          this.coreBusinessAreaFieldValue.style.color = '#005c8a';
        }
      } else {
        this.allcoreBusinesssSelected = false;
        this.coreBusinessAreaFieldValue = document.getElementById('coreBusinessArea-validation') as HTMLInputElement;
        if (this.selectCoreBusinessAreaNameValueExp) {
          if (this.coreBusinessAreaNameValue.length == 0) {
            this.selectCoreBusinessAreaNameValueExp = [];
          }
        } else {
          this.selectCoreBusinessAreaNameValueExp = this.selectCoreBusinessAreaNameValueExp.filter((x: any) => x.valueExp !== item.valueExp);
        }
      }
    }
  }

  onCoreBusinessAreaNameSelectAll(item: any) {
    this.selectCoreBusinessAreaNameValueExp = [];
    for (const element of item) {
      this.selectCoreBusinessAreaNameValueExp.push({
        valueExp: element.valueExp,
      });
    }
    if (this.coreBusinessAreaFieldValue != undefined) {
      this.coreBusinessAreaFieldValue.style.color = '#005c8a';
    }
  };

  onCoreBusinessAreaNameDeSelectAll(item: any) {
    this.selectCoreBusinessAreaNameValueExp = [];
    if (this.coreBusinessAreaFieldValue != undefined) {
      this.coreBusinessAreaFieldValue.style.color = 'red';
    }
  };

  ownerValue: any = [];
  selectedOwnerDisplayExp: any;
  selectedOwnerValueExp: any;
  ownersListDropdown: any = [];

  callOwnersListSelectBoxValues() {
    const groupOwner = this.qualityService.selectedGroupDetailData.isGroupOwnerRequired == 'Y';
    const owners = this.listOfOwnerUsers?.map((owner: any) => ({
      valueExp: owner.userId,
      displayExp: owner.userName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []

    this.ownersListDropdown = groupOwner ? [{ valueExp: 100, displayExp: 'Group Owners' }, ...owners] : owners;
  }

  onOwnerSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.selectedOwnerValueExp = item.valueExp;
        if (this.ownerFieldValue != undefined) {
          this.ownerFieldValue.style.color = '#005c8a';
        }
      } else {
        this.selectedOwnerValueExp = undefined;
        if (this.ownerFieldValue != undefined) {
          this.ownerFieldValue.style.color = 'red';
        }
      }
    }
  }


  selectedReasonForChangeDisplayExp: any;
  selectedReasonForChangeValueExp: any = [];


  setCrReason() {
    this.reasonForChangeDropdown = [];
    for (const element of this.getReasonForChangeListValues) {
      this.reasonForChangeDropdown = this.reasonForChangeDropdown.concat({
        valueExp: element.codelistCode,
        displayExp: element.codelistName
      });
    }

  }

  visibleReasonForChangeIfOthers: boolean = false;
  onReasonForChangeSelect1(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectedReasonForChangeValueExp = item.valueExp;
        if (item.valueExp == 'Others') {
          this.visibleReasonForChangeIfOthers = true;
        }
        if (this.reasonForChangeFieldValue != undefined) {
          this.reasonForChangeFieldValue.style.color = '#005c8a';
        }
      } else if (item.valueExp == 'Others') {
        this.visibleReasonForChangeIfOthers = false;
        this.qmsCRData.reasonForChange = '';
      } else if (this.selectedReasonForChangeValueExp) {
        if (this.reasonForChangeValue.length == 0) {
          this.selectedReasonForChangeValueExp = [];
          if (this.reasonForChangeFieldValue != undefined) {
            this.reasonForChangeFieldValue.style.color = 'red';
          }
        }

      } else {
        this.selectedReasonForChangeValueExp = this.selectedReasonForChangeValueExp.filter((x: any) => x.valueExp !== item.valueExp);
        if (this.selectedReasonForChangeValueExp.length == 0) {
          if (this.reasonForChangeFieldValue != undefined) {
            this.reasonForChangeFieldValue.style.color = 'red';
          }
        }
      }

      setTimeout(() => {
        this.allSelected = this.reasonForChangeDropdown.length == this.reasonForChangeValue.length;
      });
    }
  }
  onReasonForChangeSelect(item: any) {
    this.selectedReasonForChangeValueExp = item.valueExp;
    if (item.valueExp == 'Others') {
      this.visibleReasonForChangeIfOthers = true;
    }
    if (this.reasonForChangeFieldValue != undefined) {
      this.reasonForChangeFieldValue.style.color = '#005c8a';
    }
  }

  onReasonForChangeSelectAll(item: any) {
    console.log(item.valueExp);
    this.selectedReasonForChangeValueExp = [];
    for (const element of item) {
      if (element.valueExp == 'Others') {
        this.visibleReasonForChangeIfOthers = true;
        this.reasonForChangeFieldValue.style.color = 'red';
      }
      this.selectedReasonForChangeValueExp.push({
        valueExp: element.valueExp,
      });
    }
    if (this.reasonForChangeFieldValue != undefined) {
      this.reasonForChangeFieldValue.style.color = '#005c8a';
    }
  }

  onReasonForChangeDeSelectAll(item: any) {
    console.log(item.valueExp);
    this.visibleReasonForChangeIfOthers = false;
    this.selectedReasonForChangeValueExp = [];
    this.qmsCRData.reasonForChange = '';
    if (this.reasonForChangeFieldValue != undefined) {
      this.reasonForChangeFieldValue.style.color = 'red';
    }
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.CRList.length, page, this.perPage, targetpage);
    this.pagedItems = this.CRList?.slice(this.pager.startIndex, this.pager.endIndex + 1);
    this.isProcessing = false;
  }

  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBoxs = true;
      for (const element of this.CRList) {
        element.childCheckBoxs = true;
      }
    } else {
      this.childCheckBoxs = false;
      for (const element of this.CRList) {
        element.childCheckBoxs = false;
      }
    }
  }

  priviousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.priviousSelectedValue != undefined) {
        this.CRList[this.priviousSelectedValue].childCheckBoxs = false;

      }
      list.childCheckBoxs = true;
    } else {
      list.childCheckBoxs = false;
    }
    this.priviousSelectedValue = idx;
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) { }

  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(list: any, columnName: any, popupColumnName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: columnName
    }
    this.htmlContent = "";
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        console.log(Response.result);
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, popupColumnName);
      },
      error: (error) => {
        console.log(error);
      }
    });
    this.isProcessing = false;

  }
  htmlContent: any;
  tableName: any;

  getCall() {
    this.isProcessing = true;
    if (this.selectedGroupValue.length == 0) {
      alert("Please select the group");
      this.isProcessing = false;

    } else {
      this.designationCodeValue = null;
      this.departmentCodeValue = null;
      this.statusCodeValue = null;

      if (this.selectedGroupValue.length != 0) {
        this.qualityService.selectedGroup = this.selectedGroupValue[0].valueExp.toString();
      }
      this.CRList = [];
      const data = {

        gridName: this.qualityService.moduleName,
        groupId: this.qualityService.selectedGroup
      }
      this.appService.getDynamicGridHeaders(data).subscribe({
        next: (response: any) => {
          response.orderByClause ??= "";
          this.columnList = response.fieldLabelsList;

          this.makeStickyColumns = response.fixedFieldCnt;
          this.tableName = response.tableOrViewName;
          const data1: any = {

            gridName: this.qualityService.moduleName,
            tableOrViewName: response.tableOrViewName ?? "",
            columnsList: response.columnsList ?? "",
            fieldLabelsList: response.fieldLabelsList ?? "",
            invisibleColumn: response.invisibleColumn ?? "",
            orderByClause: response.orderByClause ?? "",
            fieldSizeList: response.fieldSizeList ?? "",
            columnsListarray: [],
            fieldColumnarray: [],
            invisibleColumnarray: [],
            fieldSizeListArray: [],
            status: this.statusCodeValue,
            codelistGroup: null,
            manualEntryDataFields: response.manualEntryDataFields,
            groupId: this.qualityService.selectedActivityGroupId,
            chartStatus: this.qualityService.activity.chartStatus,
            clobColumnlist: response.closblist,
            blobColumnlist: response.bloblist,
            usedAsAppend: this.chartFilter.usedAsAppend,
            filterCondition: this.chartFilter.filterCondition,
            modules: this.qualityService.moduleName,
            ...this.qualityService.moduleName == 'OOS' && { oosType: this.oosMenuType.join("','") }
          }

          this.reportObj = { ...data1, ...data };

          if (this.selectedGroupValue.length > 0) {
            data1.groupId = this.selectedGroupValue[0].valueExp.toString();
          } else {
            data1.groupId = null;
          }

          let tableData = {
            tablename: data1.tableOrViewName
          };

          forkJoin([
            this.appService.getDynamicGridData(data1),
            this.appService.tableFieldsDataType(tableData),
          ]).subscribe({
            next: ([response1, response2]) => {

              const datalabel = {

                tableName: this.tableName,
                moduleName: this.qualityService.moduleName,
                gridName: this.qualityService.moduleName,
                groupId: this.qualityService.selectedGroup,
              };

              this.appService.getreorderGirdColumnList(datalabel).subscribe({
                next: (labelResponse) => {
                  this.label = labelResponse;
                  this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
                    acc[`${user.columnName}`] = {
                      fieldName: user.changedFieldName,
                      isRemovable: user.isFieldRemovable,
                      fieldNotes: user.fieldNotes
                    };
                    return acc;
                  }, {});
                }
              });

              this.CRList = response1;

              data1.columnsListarray = data1.columnsList.split(",");
              data1.fieldColumnarray = data1.fieldLabelsList.split(",");
              data1.invisibleColumnarray = data1.invisibleColumn.split(",");
              data1.fieldSizeListArray = data1.fieldSizeList.split(",");

              this.columnLists.columnsListarray = data1.columnsListarray;
              this.columnLists.fieldLabelsList = data1.fieldLabelsList;
              this.columnLists.fieldColumnarray = [];

              for (let p = 0; p < data1.fieldColumnarray.length; p++) {
                this.columnLists.fieldColumnarray.push({
                  "fieldColumnarray": data1.fieldColumnarray[p],
                  "width": data1.fieldSizeListArray[p] + 'px'
                })
              }

              this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
              this.columnLists.fieldSizeListArray = [];

              for (const element of data1.fieldSizeListArray) {
                this.columnLists.fieldSizeListArray.push(element + 'px');
              }

              for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
                for (const element of this.columnLists.invisibleColumnarray) {
                  if (this.columnLists.columnsListarray[y] == element) {
                    this.columnLists.columnsListarray.splice(y, 1);
                    this.columnLists.fieldColumnarray.splice(y, 1);
                    this.columnLists.fieldSizeListArray.splice(y, 1);
                  }
                }
              }

              this.columnLists.columnsListarray1 = [];
              this.dataTypeList = response2;

              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;

                for (const element of this.dataTypeList) {
                  if (element.columnName == this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                  }
                }
              }

              for (const cr of this.CRList) {
                for (const element of this.dataTypeList) {
                  if (element.fieldType == 'CHECKBOX') {
                    cr[element.columnName] = cr[element.columnName] == "Y";
                  }
                }
              }

              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
              this.message.gridList = this.CRList;
              this.collectionSize = this.CRList.length;
              this.isProcessing = false;
            }
          });

        },
        error: (error) => {
          this.isProcessing = false;
          this.showSnackBar(error, "E");
        }
      });
    }
  }
  label: any = [];
  dynamicLabel: any = null;
  dynamicLabelCall() {
    this.dynamicLabel = null;
    this.isProcessing = true;
    const data = {

      tableName: this.tableName,
      moduleName: this.qualityService.moduleName,
      gridName: this.qualityService.moduleName,
      groupId: this.qualityService.selectedGroup,
    };

    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (labelResponse: any) => {

      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }
  gridResetFunction() {
    this.selectedGroupValue = [];
    this.pagedItems = [];
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();

    if (filter === '') {
      this.pagedItems = this.CRList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.CRList.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)

      );
    }
  }
  gridTemp: any;
  searchValue2: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.gridTemp = this.CRList;
      this.pager = this.paginationService.getPager(this.gridTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.CRList == undefined) {
        return this.CRList;
      }
      if (!this.CRList.length) {
        return this.CRList;
      }
      if (filter) {
        this.gridTemp = this.CRList.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });
      } else {
        this.gridTemp = this.CRList.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedorserch(1, 0);
    }
  }

  setPagedorserch(page: number, targetpage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.gridTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.gridTemp.length, page, this.perPage, targetpage);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  sortedColumn: string = '';
  sortedDisplayColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    this.isProcessing = true;
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortedDisplayColumn = list.fieldColumnarray;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.CRList.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  refreshGridData() {
    this.getCall();
  };

  @ViewChild('crAddAndEditPopup', { static: true }) crAddAndEditPopup: TemplateRef<any>;
  @ViewChild('addPopupforCAPA', { static: true }) addPopupforCAPA: TemplateRef<any>;
  @ViewChild('addAndEditOOSPopup', { static: true }) addAndEditOOSPopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleaddPopupforCAPA: MatDialogRef<TemplateRef<any>>;
  visibleaddPopupforOOS: MatDialogRef<TemplateRef<any>>;
  addAndEditPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };
  qmsCRData: any = {};
  qmsCAPAData: any = {};
  popupDataTitle: any = {};
  //visibleEditButton : boolean;
  visibleReasonForUpdateField: boolean;
  searchManagerConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };
  @ViewChild('searchManager', { static: true }) searchManager: TemplateRef<any>;
  visibleSearchManagerPopup: MatDialogRef<TemplateRef<any>>;
  searchManagerParentCheckBox: boolean = false;
  searchManagerChildCheckBoxs: boolean = false;
  searchManagerChildCheckBoxsMenu: boolean = false;
  searchManagerDataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      for (const element of this.getOneQmsUsersVwDetailsTableData) {
        element.searchManagerChildCheckBoxs = true;
      }
    } else {
      for (const element of this.getOneQmsUsersVwDetailsTableData) {
        element.searchManagerChildCheckBoxs = false;
      }
    }
  }
  showUserSearchGrid: boolean;
  searchByUserName: any = null;
  searchByFirstName: any = null;
  searchByLastName: any = null;
  searchByDesignationCode: any = [];
  searchByDepartmentCode: any = [];
  searchingByStatusCode: any = [];
  searchOneQmsUserVwDetails: any;
  getOneQmsUsersVwDetailsTableData: any = [];
  selectedDepartmentValue: any;
  selectedDesignationValue: any;
  designationCodeDropdown: any = [];

  dropDownForDesignationCode: any;
  getSelectedUserId: any;
  getSelectedUserName: string;
  selectBoxeForDesignationCode() {
    for (const element of this.dropDownForDesignationCode) {
      this.designationCodeDropdown = this.designationCodeDropdown.concat({
        valueExp: element.codelistCode,
        displayExp: element.codelistName
      });
    }
  }
  searchManagerChildCheckBoxChecked(e: any, listOfUsersVwDetails: any, idx: any) {
    if (e.target.checked) {
      listOfUsersVwDetails.searchManagerChildCheckBoxs = true;
      this.getSelectedUserId = listOfUsersVwDetails.userId;
      this.getSelectedUserName = listOfUsersVwDetails.userName;
    } else {
      listOfUsersVwDetails.searchManagerChildCheckBoxs = false;
      this.getSelectedUserId = null;
      this.getSelectedUserName = '';
    }

  }
  searchManagerFunction() {
    this.searchManagerChildCheckBoxs = false;
    this.showUserSearchGrid = false;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByDesignationCode = [];
    this.searchByDepartmentCode = [];
    this.popupDataTitle = "Search Manager";
    this.visibleSearchManagerPopup = this.dialog.open(this.searchManager, this.searchManagerConfig);
  }
  addManagerNameFunction() {
    this.qmsCRData.owner = this.getSelectedUserId;
    this.qmsCRData.ownerName = this.getSelectedUserName;
    this.visibleSearchManagerPopup.close();
  }

  cancelSearchManagerFunction() {
    this.getSelectedUserId = null;
    this.getSelectedUserName = '';
    this.visibleSearchManagerPopup.close();
  }
  onDepartmentCodeSelect(item: any) {

    this.selectedDepartmentValue = item.valueExp;
  }

  onDesignationCodeSelect(item: any) {

    this.selectedDesignationValue = item.valueExp;
  }
  searchManagerGridDataFunction() {
    let searchByUserName;
    this.isProcessing = true;
    if (this.searchByDesignationCode.length) {
      this.designationCodeValue = this.searchByDesignationCode[0].valueExp;
    } else {
      this.designationCodeValue = null;
    }
    if (this.searchByDepartmentCode.length) {
      this.departmentCodeValue = this.searchByDepartmentCode[0].valueExp;
    } else {
      this.departmentCodeValue = null;
    }
    if (this.searchByUserName) {
      searchByUserName = this.searchByUserName.toUpperCase();
    } else {
      this.searchByUserName = '';
    }
    this.searchOneQmsUserVwDetails = {
      userName: searchByUserName,
      firstName: this.searchByFirstName,
      lastName: this.searchByLastName,
      designationCode: this.designationCodeValue,
      departmentCode: this.departmentCodeValue,
      status: "active"
    };
    this.appService.getOneQmsUsersVwDetails(this.searchOneQmsUserVwDetails).subscribe((response: any) => {
      this.getOneQmsUsersVwDetailsTableData = response;
      this.showUserSearchGrid = true;
      this.isProcessing = false;
    })
  }

  resetSearchManagerGridDataFunction() {
    this.isProcessing = true;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByDesignationCode = [];
    this.searchByDepartmentCode = [];
    this.getOneQmsUsersVwDetailsTableData = [];
    this.showUserSearchGrid = false;
    this.isProcessing = false;
  }

  public objectComparisonFunction = function (option: any, value: any): boolean {
    return option.valueExp === value.valueExp;
  }
  initiatingdeptsearchTxt: any;
  deptsearchTxt: any;
  reasonForChangesearchTxt: any;
  ownersearchTxt: any;
  changeTypesearchTxt: any;
  requestedAtsearchTxt: any;
  coreBusinesssearchTxt: any;
  typeSearchText: string = '';

  capaTypesearchTxt: any;
  dvTypesearchTxt: any;

  qiTypeSearchText: string = '';
  qiDepartmentSearchText: string = '';
  referenceSearchText: string = '';
  requestedSearchText: string = '';
  coreBusinessSearchText: string = '';
  evaluatorSearchText: string = '';
  impactTypeSearchText: string = '';
  excelPdfSearchText: string = '';
  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  }
  @ViewChild('reasonForChange') reasonForChange: MatSelect;
  @ViewChild('allcoreBusinesss') allcoreBusinesss: MatSelect;
  @ViewChild('reasonForCapa') reasonForCapa: MatSelect;
  @ViewChild('allcoreBusinesssCapa') allcoreBusinesssCapa: MatSelect;
  @ViewChild('reasonForDv') reasonForDv: MatSelect;
  @ViewChild('allcoreBusinesssDv') allcoreBusinesssDv: MatSelect;

  allSelected = false;
  allcoreBusinesssSelected = false;
  allSelectedCapa = false;
  allcoreBusinesssSelectedCapa = false;
  allSelectedDv = false;
  allcoreBusinesssSelectedDv = false;
  toggleAllSelection1(value: any) {
    if (value == 'allcoreBusinesssSelected') {
      if (this.allcoreBusinesssSelected) {
        this.allcoreBusinesss.options.forEach((item: MatOption) => item.select());
      } else {
        this.allcoreBusinesss.options.forEach((item: MatOption) => item.deselect());
      }
    } else if (value == 'reasonForChange') {
      [this.qmsCRData.reasonForChange, this.visibleReasonForChangeIfOthers] = [null, this.allSelected];
      if (this.allSelected) {
        this.reasonForChange.options.forEach((item: MatOption) => item.select());
      } else {
        this.reasonForChange.options.forEach((item: MatOption) => item.deselect());
      }
    } else if (value == 'allcoreBusinesssSelectedCapa') {
      if (this.allcoreBusinesssSelectedCapa) {
        this.allcoreBusinesssCapa.options.forEach((item: MatOption) => item.select());
      } else {
        this.allcoreBusinesssCapa.options.forEach((item: MatOption) => item.deselect());
      }
    } else if (value == 'reasonForCapa') {
      [this.qmsCapaFieldData.reasonForCapa, this.visibleReasonForCapaIfOthers] = [null, this.allSelectedCapa];
      if (this.allSelectedCapa) {
        this.reasonForCapa.options.forEach((item: MatOption) => item.select());
      } else {
        this.reasonForCapa.options.forEach((item: MatOption) => item.deselect());
      }
    } else if (value == 'allcoreBusinesssSelectedDv') {
      if (this.allcoreBusinesssSelectedDv) {
        this.allcoreBusinesssDv.options.forEach((item: MatOption) => item.select());
      } else {
        this.allcoreBusinesssDv.options.forEach((item: MatOption) => item.deselect());
      }
    } else if (value == 'reasonForDv') {
      [this.qmsCapaFieldData.reasonForDeviation, this.visibleReasonForDivationIfOthers] = [null, this.allSelectedDv];
      if (this.allSelectedDv) {
        this.reasonForDv.options.forEach((item: MatOption) => item.select());
      } else {
        this.reasonForDv.options.forEach((item: MatOption) => item.deselect());
      }
    }
  }

  onTabChanged($event: any) {
    this.selectedTabIndex = $event.index;
  }

  openAddPopup() {
    if (this.selectedGroupValue.length == 0) {
      alert('Please select the group');
    } else {
      this.qualityService.activityId = null;
      this.showChangeTypeIfNa = false;
      if (this.qualityService.moduleName == "CR") {
        this.visibleEditButton = false;
        this.visibleReasonForUpdateField = false;
        this.qmsCRData = {

          groupId: null,
          groupCode: null,
          groupName: null,
          groupDescription: null,
          isActive: true,
          modules: null,
          deleteReason: null,
          shortDescription: null,
          changeDescription: null,
          changeJustification: null,
          reasonForChangeIfOthers: undefined,
          reasonForChange: ""
        }
        this.departmentCode = null;
        this.ownerValue = null;
        this.requestedAtValue = null;
        this.coreBusinessAreaNameValue = [];
        this.coreBusinessAreaNameDropdown = [];
        this.changeTypeValue = null;
        this.reasonForChangeValue = [];
        this.bussinessAreaName = undefined;
        this.visibleReasonForChangeIfOthers = false;
        this.qmsCRData.expcetedClosureOn = null;
        this.qmsCRData.effectivenessCheckReqd = false;
        if (this.qualityService.selectedGroupDetailData.isRiskCalculationReqd == 'Y') {
          this.qmsCRData.isRiskCalculationReqd = true;
        } else {
          this.qmsCRData.isRiskCalculationReqd = false;
        }
        this.popupTitle = "Create " + this.qualityService.moduleFullName;
        this.visibleAddAndEditPopup = this.dialog.open(this.crAddAndEditPopup, this.addAndEditPopupConfig);

      } else if (this.qualityService.moduleName == "CAPA") {
        this.qmsCAPAData = {

          groupId: null,
          groupCode: null,
          groupName: null,
          groupDescription: null,
          isActive: true,
          modules: null,
        }
        this.departmentCode = [];
        this.ownerValue = [];
        this.requestedAtValue = [];
        this.coreBusinessAreaNameValue = [];
        this.capaCoreBusinessAreaNameDropdown = [];
        this.changeTypeValue = [];
        this.reasonForChangeValue = [];
        this.bussinessAreaName = undefined;
        this.visibleReasonForChangeIfOthers = false;
        this.visibleaddPopupforCAPA = this.dialog.open(this.addPopupforCAPA, this.addAndEditPopupConfig);
      }
    }
  }

  changeExpcetedClosureOnDate(items: any) {
    this.expcetedClosureOnFieldValue = document.getElementById('expcetedClosureOn-validation') as HTMLInputElement;
    if (items != null || items != undefined) {
      this.expcetedClosureOnFieldValue && (this.expcetedClosureOnFieldValue.style.color = '#005c8a');
    } else {
      this.expcetedClosureOnFieldValue && (this.expcetedClosureOnFieldValue.style.color = 'red');
    }
  }

  userTimeZone: string = Intl.DateTimeFormat().resolvedOptions().timeZone;
  changeexpectedToBeStartedOnDate(items: any) {
    const localDate = moment.tz(items, this.userTimeZone).format();
    console.log('Selected Date in User Time Zone:', localDate);

    // Convert to UTC or any other time zone if needed
    const utcDate = moment(items).utc().format();
    console.log('Selected Date in UTC:', utcDate);
    this.expectedToBeStartedOnFieldValue = document.getElementById('expectedToBeStartedOn-validation') as HTMLInputElement;
    if (items != null || items != undefined) {
      this.expectedToBeStartedOnFieldValue && (this.expectedToBeStartedOnFieldValue.style.color = '#005c8a');
    } else {
      this.expectedToBeStartedOnFieldValue && (this.expectedToBeStartedOnFieldValue.style.color = 'red');
    }
  }

  departmentFieldValue: any;
  ownerFieldValue: any;
  requestedAtFieldValue: any;
  coreBusinessAreaFieldValue: any;
  expcetedClosureOnFieldValue: any;
  expectedToBeStartedOnFieldValue: any;
  shortDescriptionFieldValue: any;
  changeDescriptionFieldValue: any;
  changeJustificationFieldValue: any;
  reasonForChangeFieldValue: any;
  reasonForChangeIfOthersFieldValue: any;
  fieldValidation() {
    this.departmentFieldValue = document.getElementById('department-validation') as HTMLInputElement;
    this.ownerFieldValue = document.getElementById('owner-validation') as HTMLInputElement;
    this.requestedAtFieldValue = document.getElementById('requestedAt-validation') as HTMLInputElement;
    this.coreBusinessAreaFieldValue = document.getElementById('coreBusinessArea-validation') as HTMLInputElement;
    this.expcetedClosureOnFieldValue = document.getElementById('expcetedClosureOn-validation') as HTMLInputElement;
    this.expectedToBeStartedOnFieldValue = document.getElementById('expectedToBeStartedOn-validation') as HTMLInputElement;
    this.shortDescriptionFieldValue = document.getElementById('shortDescription-validation') as HTMLInputElement;
    this.changeDescriptionFieldValue = document.getElementById('changeDescription-validation') as HTMLInputElement;
    this.changeJustificationFieldValue = document.getElementById('changeJustification-validation') as HTMLInputElement;
    this.reasonForChangeFieldValue = document.getElementById('reasonForChange-validation') as HTMLInputElement;
    this.reasonForChangeIfOthersFieldValue = document.getElementById('reasonForChangeIfOthers-validation') as HTMLInputElement;

    if (this.departmentCode == null) {
      this.departmentFieldValue.style.color = 'red';
    } else {
      this.departmentFieldValue.style.color = '#005c8a';
    }

    if (this.ownerValue == null) {
      this.ownerFieldValue.style.color = 'red';
    } else {
      this.ownerFieldValue.style.color = '#005c8a';
    }
    if (this.requestedAtValue == null) {
      this.requestedAtFieldValue.style.color = 'red';
    } else {
      this.requestedAtFieldValue.style.color = '#005c8a';
    }

    if (this.requestedAtValue == null) {
      if (this.coreBusinessAreaNameValue.length == 0) {
        this.coreBusinessAreaFieldValue.style.color = 'red';
      }
    } else if (this.coreBusinessAreaNameValue.length == 0) {
      this.coreBusinessAreaFieldValue.style.color = 'red';
    } else {
      this.coreBusinessAreaFieldValue.style.color = '#005c8a';
    }


    if (this.qmsCRData.expcetedClosureOn == null || this.qmsCRData.expcetedClosureOn == undefined) {
      this.expcetedClosureOnFieldValue.style.color = 'red';
    } else {
      this.expcetedClosureOnFieldValue.style.color = '#005c8a';
    }

    if (this.qmsCRData.expectedToBeStartedOn == null || this.qmsCRData.expectedToBeStartedOn == undefined) {
      this.expectedToBeStartedOnFieldValue.style.color = 'red';
    } else {
      this.expectedToBeStartedOnFieldValue.style.color = '#005c8a';
    }

    if (this.qmsCRData.shortDescription == "" || this.qmsCRData.shortDescription == undefined) {
      this.shortDescriptionFieldValue.style.color = 'red';
    } else {
      this.shortDescriptionFieldValue.style.color = '#005c8a';
    }

    if (this.qmsCRData.changeDescription == "" || this.qmsCRData.changeDescription == undefined) {
      this.changeDescriptionFieldValue.style.color = 'red';
    } else {
      this.changeDescriptionFieldValue.style.color = '#005c8a';
    }

    if (this.qmsCRData.changeJustification == "" || this.qmsCRData.changeJustification == undefined) {
      this.changeJustificationFieldValue.style.color = 'red';
    } else {
      this.changeJustificationFieldValue.style.color = '#005c8a';
    }

    if (this.reasonForChangeValue.length == 0) {
      this.reasonForChangeFieldValue.style.color = 'red';
    } else {
      this.reasonForChangeFieldValue.style.color = '#005c8a';
      if (this.reasonForChangeIfOthersFieldValue != undefined || this.reasonForChangeIfOthersFieldValue != null) {
        if (this.qmsCRData.reasonForChangeIfOthers == "" || this.qmsCRData.reasonForChangeIfOthers == undefined) {
          this.reasonForChangeIfOthersFieldValue.style.color = 'red';
        } else {
          this.reasonForChangeIfOthersFieldValue.style.color = '#005c8a';
        }
      }
    }
  }

  pushedCoreBusinessAreaName: any = [];
  pushedReasonForChange: any = [];

  addAndEditFunction(qmsCRData: any) {
    this.isProcessing = true;
    this.reasonForChangeIfOthersFieldValue = document.getElementById('reasonForChangeIfOthers-validation') as HTMLInputElement;
    this.pushedCoreBusinessAreaName = [];
    this.pushedReasonForChange = [];


    if ((!this.departmentCode && this.dynamicLabel['DEPT_NAME'].isRemovable != 'Y') || !this.ownerValue ||
      (this.requestedAtValue == null) || (this.coreBusinessAreaNameValue.length == 0) ||
      (this.reasonForChangeValue.length == 0 && this.dynamicLabel['REASON_FOR_CHANGE'].isRemovable != 'Y')
      || qmsCRData.expcetedClosureOn == null
      || (qmsCRData.expectedToBeStartedOn == null && this.dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].isRemovable != 'Y')
      || qmsCRData.shortDescription == undefined
      || (qmsCRData.changeDescription == undefined && this.dynamicLabel['CHANGE_DESCRIPTION'].isRemovable != 'Y')
      || (qmsCRData.changeJustification == undefined && this.dynamicLabel['CHANGE_JUSTIFICATION'].isRemovable != 'Y')) {
      this.fieldValidation();
      alert('Please enter the all mandatory fields...');
      this.isProcessing = false;
    }
    else {

      if (this.departmentCode) {
        qmsCRData.deptCode = this.departmentCode;
      } else {
        qmsCRData.deptCode = null;
      }

      if (this.ownerValue) {
        qmsCRData.owner = this.ownerValue;
      } else {
        qmsCRData.owner = null;
      }

      if (this.qmsCRData.expcetedClosureOn) {
        qmsCRData.expcetedClosureOn = new Date(this.qmsCRData.expcetedClosureOn);
        qmsCRData.expcetedClosureOn = this.appService.dateZoneConvertion(qmsCRData.expcetedClosureOn);
      } else {
        qmsCRData.expcetedClosureOn = null;
      }

      if (this.requestedAtValue) {
        qmsCRData.requestedAt = this.requestedAtValue;
      } else {
        qmsCRData.requestedAt = null;
      }

      if (this.coreBusinessAreaNameDropdown.length > 0) {
        if (this.coreBusinessAreaNameValue != undefined || this.coreBusinessAreaNameValue.length != 0) {
          for (const element of this.coreBusinessAreaNameValue) {
            this.pushedCoreBusinessAreaName.push(element);
          }
          qmsCRData.coreBusinessAreaName = this.pushedCoreBusinessAreaName.toString();
        } else {
          qmsCRData.coreBusinessAreaName = null;
        }
      } else {
        qmsCRData.coreBusinessAreaName = this.coreBusinessAreaNameValue;
      }


      if (this.changeTypeValue) {
        qmsCRData.changeTypeCode = this.changeTypeValue;
      } else {
        qmsCRData.changeTypeCode = null;
      }

      if (this.reasonForChangeValue != undefined || this.reasonForChangeValue.length != 0) {
        for (const element of this.reasonForChangeValue) {
          this.pushedReasonForChange.push(element);
          if (element == 'Others') {
            if (qmsCRData.reasonForChange == undefined || qmsCRData.reasonForChange == '') {
              this.reasonForChangeIfOthersFieldValue.style.color = 'red';
              this.isProcessing = false;
              alert('Please enter the all mandatory fields...');
              return;
            }
          }
        }
        qmsCRData.reasonForChangeCode = this.pushedReasonForChange.toString();
      } else {
        qmsCRData.reasonForChangeCode = null;
      }

      if (this.qmsCRData.expectedToBeStartedOn) {
        qmsCRData.expectedToBeStartedOn = new Date(this.qmsCRData.expectedToBeStartedOn);
        qmsCRData.expectedToBeStartedOn = this.appService.dateZoneConvertion(qmsCRData.expectedToBeStartedOn);
      } else {
        qmsCRData.expectedToBeStartedOn = null;
      }
      let data = {
        groupId: this.selectedGroupValue[0].valueExp,
        deptCode: this.qmsCRData.deptCode,
        owner: this.qmsCRData.owner,
        requestedAt: this.qmsCRData.requestedAt,
        coreBusinessAreaName: this.qmsCRData.coreBusinessAreaName,
        reasonForChange: this.qmsCRData.reasonForChange,
        reasonForChangeCode: this.qmsCRData.reasonForChangeCode,
        changeTypeCode: this.qmsCRData.changeTypeCode,
        shortDescription: this.qmsCRData.shortDescription,
        changeDescription: this.qmsCRData.changeDescription,
        changeJustification: this.qmsCRData.changeJustification,
        expcetedClosureOn: qmsCRData.expcetedClosureOn,
        effectivenessCheckReqd: this.qmsCRData.effectivenessCheckReqd ? "Y" : "N",
        expectedToBeStartedOn: this.qmsCRData.expectedToBeStartedOn,
        isRiskCalculationReqd: this.qmsCRData.isRiskCalculationReqd ? "Y" : "N"
      }

      this.appService.createCr(data).subscribe({
        next: (Response: any) => {
          this.message.lastmsg = Response;
          if (Response.resultType == 'S') {
            this.getCall();
            this.qualityService.activityId = Response.ID;
            if (this.flexibleComponent.flexibleFields.length) { this.flexibleComponent.save('Master', +Response.ID); }
            this.visibleAddAndEditPopup.close();
            this.isProcessing = false;
          }
          this.showSnackBar(Response.result, Response.resultType);
          this.isProcessing = false;
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  /* Start - CAPA */
  @ViewChild('capaAddPopup', { static: true }) capaAddPopup: TemplateRef<any>;
  visibleCapaAddPopup: MatDialogRef<TemplateRef<any>>;

  qmsCapaFieldData: any = {};
  selectedCapaDepartmentValue: any = null;
  capaDepartmentCodeDropdown: any = [];
  selectedCapaOwnerValue: any = null;
  capaOwnersListDropdown: any = [];
  selectedCapaTypeValue: any = null;
  capaTypeDropdown: any = [];
  selectedCapaRequestedAtValue: any = null;
  capaRequestedAtDropdown: any = [];
  selectedCapaCoreBusinessAreaNameValue: any = [];
  capaCoreBusinessAreaNameDropdown: any = [];
  selectedReasonForCapaValue: any = [];
  reasonForCapaDropdown: any = [];


  onCapaDepartmentCodeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (this.departmentFieldValue != undefined) {
          this.departmentFieldValue.style.color = '#005c8a';
        }
      } else {
        this.departmentFieldValue = document.getElementById('department-validation') as HTMLInputElement;
        if (this.departmentFieldValue != undefined) {
          this.departmentFieldValue.style.color = 'red';
        }
      }
    }
  }

  onCapaOwnerSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {

        if (this.ownerFieldValue != undefined) {
          this.ownerFieldValue.style.color = '#005c8a';
        }
      } else {

        this.ownerFieldValue = document.getElementById('owner-validation') as HTMLInputElement;
        if (this.ownerFieldValue != undefined) {
          this.ownerFieldValue.style.color = 'red';
        }
      }
    }
  }

  showCapaChangeTypeIfNa: boolean = false;
  onCapaTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.isProcessing = true;
        this.expcetedToStartedOnFieldValue = document.getElementById('capaExpcetedToStarted-validation') as HTMLInputElement;
        this.expcetedClosureOnFieldValue = document.getElementById('capaExpcetedClosureOn-validation') as HTMLInputElement;
        if (item.valueExp == 'NA') {
          this.showCapaChangeTypeIfNa = true;
          this.isProcessing = false;
        } else {
          this.appService.getTypeSettingsByType(this.qualityService.selectedActivityGroupId, this.qualityService.selectedGroupDetailId, item.valueExp).subscribe((response: any) => {
            if (response != null) {
              if (response.toBeStartedInDays) {
                let date = new Date();

                date.setDate(date.getDate() + response.toBeStartedInDays);
                this.qmsCapaFieldData.expectedToBeStartedOn = date;
                this.expcetedToStartedOnFieldValue.style.color = '#005c8a';
              } else {
                this.qmsCapaFieldData.expectedToBeStartedOn = null;
              }

              if (response.toBeClosedInDays) {
                let date = new Date();
                this.qmsCapaFieldData.expectedToBeStartedOn == null ? date.setDate(date.getDate() + response.toBeClosedInDays) : date.setDate(date.getDate() + response.toBeStartedInDays + response.toBeClosedInDays);
                this.qmsCapaFieldData.expcetedClosureOn = date;
                this.expcetedClosureOnFieldValue.style.color = '#005c8a';
              } else {
                this.qmsCapaFieldData.expcetedClosureOn = null;
              }
            }

            this.isProcessing = false;
          })
          this.showCapaChangeTypeIfNa = false;
        }
      } else {
        this.showCapaChangeTypeIfNa = false;
      }
    }
  }

  onCapaRequestedAtSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.selectedCapaCoreBusinessAreaNameValue = [];
        this.selectedCapaCoreBusinessAreaNameValue = [];

        this.bussinessAreaName = item.displayExp;
        let businessAreaValues = this.filteredRequestedAtValue.filter((x: any) => x.taskRequestedAt === item.displayExp);
        if (businessAreaValues.length != 0) {
          this.filteredBusinessAreaValue = businessAreaValues[0].listOfBusinessArea?.split(',');
          this.selectBoxForCapaCoreBusinessAreaName();
        }

        this.selectBoxForDvCoreBusinessAreaName();
        if (this.requestedAtFieldValue != undefined) {
          this.requestedAtFieldValue.style.color = '#005c8a';
        }

      } else {
        this.requestedAtFieldValue = document.getElementById('requestedAt-validation') as HTMLInputElement;
        if (this.requestedAtFieldValue != undefined) {
          this.requestedAtFieldValue.style.color = 'red';
        }

        if (this.selectedCapaTypeValue == null) {
          this.selectedCapaCoreBusinessAreaNameValue = [];
          this.capaCoreBusinessAreaNameDropdown = [];
          this.bussinessAreaName = undefined;
        }
      }
      setTimeout(() => { this.flexibleComponent.triggerFromRequestedAt(item.valueExp) })
    }
  }

  onCapaCoreBusinessAreaNameSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectCoreBusinessAreaNameValueExp = item.valueExp;
        setTimeout(() => {
          this.allcoreBusinesssSelectedCapa = this.capaCoreBusinessAreaNameDropdown.length == this.selectedCapaCoreBusinessAreaNameValue.length;
        });
        if (this.coreBusinessAreaFieldValue != undefined) {
          this.coreBusinessAreaFieldValue.style.color = '#005c8a';
        }
      } else {

        this.allcoreBusinesssSelectedCapa = false;
        this.coreBusinessAreaFieldValue = document.getElementById('coreBusinessArea-validation') as HTMLInputElement;
        if (this.coreBusinessAreaNameValue.length == 0) {
          if (this.coreBusinessAreaFieldValue != undefined) {
            this.coreBusinessAreaFieldValue.style.color = 'red';
          }
        }
      }
    }
  }

  onCapaCoreBusinessAreaNameDeSelectAll(item: any) {
    this.coreBusinessAreaFieldValue = document.getElementById('coreBusinessArea-validation') as HTMLInputElement;
    this.selectCoreBusinessAreaNameValueExp = [];
    if (this.coreBusinessAreaFieldValue != undefined) {
      this.coreBusinessAreaFieldValue.style.color = 'red';
    }
  };

  capaExpcetedClosureOnDate(items: any) {
    this.expcetedClosureOnFieldValue = document.getElementById('capaExpcetedClosureOn-validation') as HTMLInputElement;
    if (items != null || items != undefined) {
      this.expcetedClosureOnFieldValue.style.color = '#005c8a';
    } else {
      this.expcetedClosureOnFieldValue.style.color = 'red';
    }
  }

  capaExpectedToBeStartedOnDate(items: any) {
    this.expcetedToStartedOnFieldValue = document.getElementById('capaExpcetedToStarted-validation') as HTMLInputElement;
    if (items != null || items != undefined) {
      this.expcetedToStartedOnFieldValue.style.color = '#005c8a';
    } else {
      this.expcetedToStartedOnFieldValue.style.color = 'red';
    }
  }

  selectedReasonForCapaValueExp: any = [];
  visibleReasonForCapaIfOthers: boolean = false;
  onReasonForCapaSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectedReasonForCapaValueExp = item.valueExp;
        if (item.valueExp == 'Others') {
          this.visibleReasonForCapaIfOthers = true;
        }
        if (this.reasonForCapaFieldValue != undefined) {
          this.reasonForCapaFieldValue.style.color = '#005c8a';
        }
      } else {
        this.reasonForCapaFieldValue = document.getElementById('reasonForCapa-validation') as HTMLInputElement;
        if (item.valueExp == 'Others') {
          this.visibleReasonForCapaIfOthers = false;
          this.qmsCapaFieldData.reasonForCapa = '';
        } else if (this.selectedReasonForCapaValue?.length == 0) {
          this.selectedReasonForCapaValueExp = [];
          if (this.reasonForCapaFieldValue != undefined) {
            this.reasonForCapaFieldValue.style.color = 'red';
          }
        }
      }
      setTimeout(() => {
        this.allSelectedCapa = this.reasonForCapaDropdown.length == this.selectedReasonForCapaValue.length;
      });
    }
  }

  onReasonForCapaSelectAll(item: any) {
    console.log(item.valueExp);
    this.selectedReasonForCapaValueExp = [];
    for (const element of item) {
      this.selectedReasonForCapaValueExp.push({
        valueExp: element.valueExp,
      });
    }
    if (this.reasonForCapaFieldValue != undefined) {
      this.reasonForCapaFieldValue.style.color = '#005c8a';
    }
  }

  onReasonForCapaDeSelectAll(item: any) {
    console.log(item.valueExp);
    this.reasonForCapaFieldValue = document.getElementById('reasonForCapa-validation') as HTMLInputElement;
    this.visibleReasonForCapaIfOthers = false;
    this.selectedReasonForCapaValueExp = [];
    this.qmsCapaFieldData.reasonForCapa = '';
    if (this.reasonForCapaFieldValue != undefined) {
      this.visibleReasonForCapaIfOthers = false
      this.reasonForCapaFieldValue.style.color = 'red';
    }
  }

  selectBoxForCapaDepartmentCode() {
    this.capaDepartmentCodeDropdown = [];
    for (const element of this.dropDownForDepartmentCode) {
      this.capaDepartmentCodeDropdown = this.capaDepartmentCodeDropdown.concat({
        valueExp: element.codelistCode,
        displayExp: element.codelistName
      });
    }
  }

  selectBoxForCapaOwnerList() {
    this.capaOwnersListDropdown = [];
    for (let j = 0; j < this.listOfOwnerUsers?.length; j++) {
      this.capaOwnersListDropdown = this.capaOwnersListDropdown.concat({
        valueExp: this.listOfOwnerUsers[j].userId,
        displayExp: this.listOfOwnerUsers[j].userName
      });
    }

    const groupOwner = this.qualityService.selectedGroupDetailData.isGroupOwnerRequired == 'Y';
    const owners = this.listOfOwnerUsers?.map((owner: any) => ({
      valueExp: owner.userId,
      displayExp: owner.userName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []

    this.capaOwnersListDropdown = groupOwner ? [{ valueExp: 100, displayExp: 'Group Owners' }, ...owners] : owners;
  }

  selectBoxForCapaType() {
    this.capaTypeDropdown = [];
    this.capaTypeDropdown = this.dropDownForChangeType?.map((item: any) => ({
      valueExp: item.type,
      displayExp: item.type
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) || []
  }

  selectBoxForCapaRequestedAt() {
    this.capaRequestedAtDropdown = [];
    this.filteredRequestedAtValue = this.getQmsBusinessAreaDetail.filter((x: any) => x.module === this.message.changeRequestCode);
    for (const element of this.filteredRequestedAtValue) {
      this.capaRequestedAtDropdown = this.capaRequestedAtDropdown.concat({
        valueExp: element.taskRequestedAt,
        displayExp: element.taskRequestedAt
      });
    }
  }

  selectBoxForCapaCoreBusinessAreaName() {
    this.capaCoreBusinessAreaNameDropdown = [];
    for (let i = 0; i < this.filteredBusinessAreaValue?.length; i++) {
      this.capaCoreBusinessAreaNameDropdown = this.capaCoreBusinessAreaNameDropdown.concat({
        valueExp: this.filteredBusinessAreaValue[i],
        displayExp: this.filteredBusinessAreaValue[i]
      });
    }
  }

  setCapaReason() {
    this.reasonForCapaDropdown = [];
    for (const element of this.getReasonForChangeListValues) {
      this.reasonForCapaDropdown = this.reasonForCapaDropdown.concat({
        valueExp: element.codelistCode,
        displayExp: element.codelistName
      });
    }
  }

  @Input() dynamicLabelData: any = null;

  openCapaAddPopup() {
    this.qualityService.activityId = null;
    this.selectedCapaDepartmentValue = null;
    this.selectedCapaOwnerValue = null;
    this.selectedCapaTypeValue = null;
    this.selectedCapaRequestedAtValue = null;
    this.selectedCapaCoreBusinessAreaNameValue = [];
    this.capaCoreBusinessAreaNameDropdown = [];
    this.selectedReasonForCapaValue = [];
    this.qmsCapaFieldData.expcetedClosureOn = null;
    this.qmsCapaFieldData.expectedToBeStartedOn = null;
    this.qmsCapaFieldData.shortDescription = "";
    this.qmsCapaFieldData = {};
    this.qmsCapaFieldData.capaDescription = "";
    this.qmsCapaFieldData.effectivenessCheckReqd = false;
    if (this.qualityService.selectedGroupDetailData.isRiskCalculationReqd == 'Y') {
      this.qmsCapaFieldData.isRiskCalculationReqd = true;
    } else {
      this.qmsCapaFieldData.isRiskCalculationReqd = false;
    }
    this.visibleReasonForCapaIfOthers = false;
    this.bussinessAreaName = undefined;
    this.popupDataTitle.title = "Create " + this.qualityService.moduleFullName;;
    this.visibleCapaAddPopup = this.dialog.open(this.capaAddPopup, this.addAndEditPopupConfig);
  }

  onCapaFieldFocusout() {
    this.shortDescriptionFieldValue = document.getElementById('capaShortDescription-validation') as HTMLInputElement;
    this.capaDescriptionFieldValue = document.getElementById('capaDescription-validation') as HTMLInputElement;
    if (this.shortDescriptionFieldValue) {
      if (this.qmsCapaFieldData.shortDescription == "" || this.qmsCapaFieldData.shortDescription == undefined) {
        this.shortDescriptionFieldValue.style.color = 'red';
      } else {
        this.shortDescriptionFieldValue.style.color = '#005c8a';
      }
    } else if (this.qmsCapaFieldData.shortDescription == "" || this.qmsCapaFieldData.shortDescription == undefined) {
      this.shortDescriptionFieldValue.style.color = 'red';
    } else {
      this.shortDescriptionFieldValue.style.color = '#005c8a';
    }

    if (this.capaDescriptionFieldValue) {
      if (this.qmsCapaFieldData.capaDescription == "" || this.qmsCapaFieldData.capaDescription == undefined) {
        this.capaDescriptionFieldValue.style.color = 'red';
      } else {
        this.capaDescriptionFieldValue.style.color = '#005c8a';
      }
    } else if (this.qmsCapaFieldData.capaDescription == "" || this.qmsCapaFieldData.capaDescription == undefined) {
      this.capaDescriptionFieldValue.style.color = 'red';
    } else {
      this.capaDescriptionFieldValue.style.color = '#005c8a';
    }
  }

  reasonForCapaFieldValue: any;
  auGroupFieldValue: any;
  expcetedToStartedOnFieldValue: any;
  capaDescriptionFieldValue: any;
  capaFieldValidation() {
    this.auGroupFieldValue = document.getElementById('auGroup-validation') as HTMLInputElement;
    this.departmentFieldValue = document.getElementById('capaDepartment-validation') as HTMLInputElement;
    this.ownerFieldValue = document.getElementById('capaOwner-validation') as HTMLInputElement;
    this.requestedAtFieldValue = document.getElementById('capaRequestedAt-validation') as HTMLInputElement;
    this.coreBusinessAreaFieldValue = document.getElementById('capaCoreBusinessArea-validation') as HTMLInputElement;
    this.expcetedClosureOnFieldValue = document.getElementById('capaExpcetedClosureOn-validation') as HTMLInputElement;
    this.reasonForCapaFieldValue = document.getElementById('reasonForCapa-validation') as HTMLInputElement;
    this.shortDescriptionFieldValue = document.getElementById('capaShortDescription-validation') as HTMLInputElement;
    this.expcetedToStartedOnFieldValue = document.getElementById('capaExpcetedToStarted-validation') as HTMLInputElement;
    this.capaDescriptionFieldValue = document.getElementById('capaDescription-validation') as HTMLInputElement;

    if (this.selectedCapaDepartmentValue == null) {
      this.departmentFieldValue.style.color = 'red';
    } else {
      this.departmentFieldValue.style.color = '#005c8a';
    }

    if (this.selectedCapaOwnerValue == null) {
      this.ownerFieldValue.style.color = 'red';
    } else {
      this.ownerFieldValue.style.color = '#005c8a';
    }

    if (this.selectedCapaRequestedAtValue == null) {
      this.requestedAtFieldValue.style.color = 'red';
    } else {
      this.requestedAtFieldValue.style.color = '#005c8a';
    }

    if (this.selectedCapaRequestedAtValue && this.coreBusinessAreaFieldValue) {
      if (this.selectedCapaCoreBusinessAreaNameValue.length == 0) {
        this.coreBusinessAreaFieldValue.style.color = 'red';
      }
    } else if (this.selectedCapaCoreBusinessAreaNameValue.length == 0) {
      if (this.coreBusinessAreaFieldValue) this.coreBusinessAreaFieldValue.style.color = 'red';
    } else if (this.coreBusinessAreaFieldValue) {
      this.coreBusinessAreaFieldValue.style.color = '#005c8a';
    }

    if (this.selectedReasonForCapaValue?.length == 0) {
      this.reasonForCapaFieldValue.style.color = 'red';
    } else {
      this.reasonForCapaFieldValue.style.color = '#005c8a';
    }

    if (this.qmsCapaFieldData.expcetedClosureOn == null || this.qmsCapaFieldData.expcetedClosureOn == undefined) {
      this.expcetedClosureOnFieldValue.style.color = 'red';
    } else {
      this.expcetedClosureOnFieldValue.style.color = '#005c8a';
    }

    if (this.qmsCapaFieldData.expectedToBeStartedOn == null || this.qmsCapaFieldData.expectedToBeStartedOn == undefined) {
      this.expcetedToStartedOnFieldValue.style.color = 'red';
    } else {
      this.expcetedToStartedOnFieldValue.style.color = '#005c8a';
    }

    if (this.qmsCapaFieldData.capaDescription == "" || this.qmsCapaFieldData.capaDescription == undefined) {
      this.capaDescriptionFieldValue.style.color = 'red';
    } else {
      this.capaDescriptionFieldValue.style.color = '#005c8a';
    }

    if (this.qmsCapaFieldData.shortDescription == "" || this.qmsCapaFieldData.shortDescription == undefined) {
      this.shortDescriptionFieldValue.style.color = 'red';
    } else {
      this.shortDescriptionFieldValue.style.color = '#005c8a';
    }

  }

  capaSaveButtonFuntion(fieldData: any) {
    this.isProcessing = true;
    this.reasonForChangeIfOthersFieldValue = document.getElementById('reasonForChangeIfOthers-validation') as HTMLInputElement;

    console.log(fieldData);
    if ((this.selectedCapaDepartmentValue == null && this.dynamicLabel['DEPT_NAME'].isRemovable != 'Y')
      || !this.selectedCapaOwnerValue
      || this.selectedCapaRequestedAtValue == null
      || this.selectedCapaCoreBusinessAreaNameValue.length == 0
      || (this.selectedReasonForCapaValue?.length == 0 && this.dynamicLabel['REASON_FOR_CAPA_CODE'].isRemovable != 'Y')
      || fieldData.expcetedClosureOn == null
      || fieldData.shortDescription == ""
      || (fieldData.expectedToBeStartedOn == null && this.dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].isRemovable != 'Y')
      || fieldData.capaDescription == "") {
      this.capaFieldValidation();
      alert('Please enter the all mandatory fields...');
      this.isProcessing = false;
    } else {
      delete fieldData.createdOn;
      delete fieldData.updatedOn;

      if (this.selectedCapaDepartmentValue) {
        fieldData.deptCode = this.selectedCapaDepartmentValue;
      } else {
        fieldData.deptCode = null;
      }

      if (this.selectedCapaOwnerValue) {
        fieldData.owner = this.selectedCapaOwnerValue;
      } else {
        fieldData.owner = null;
      }

      if (this.selectedCapaTypeValue) {
        fieldData.capaType = this.selectedCapaTypeValue;
      } else {
        fieldData.capaType = null;
      }

      if (this.selectedCapaRequestedAtValue) {
        fieldData.requestedAt = this.selectedCapaRequestedAtValue;
      } else {
        fieldData.requestedAt = null;
      }

      if (this.capaCoreBusinessAreaNameDropdown.length > 0) if (this.selectedCapaCoreBusinessAreaNameValue.length > 0) {
        fieldData.coreBusinessAreaName = this.selectedCapaCoreBusinessAreaNameValue.join(',');
      } else {
        fieldData.coreBusinessAreaName = null;
      } else {
        fieldData.coreBusinessAreaName = this.selectedCapaCoreBusinessAreaNameValue;
      }

      this.pushedReasonForChange = [];
      if (this.selectedReasonForCapaValue != undefined || this.selectedReasonForCapaValue?.length != 0) {
        for (let j = 0; j < this.selectedReasonForCapaValue?.length; j++) {
          this.pushedReasonForChange.push(this.selectedReasonForCapaValue[j]);
          if (this.selectedReasonForCapaValue[j] == 'Others') {
            if (fieldData.reasonForCapa == undefined || fieldData.reasonForCapa == '') {
              this.reasonForChangeIfOthersFieldValue.style.color = 'red';
              this.isProcessing = false;
              alert('Please enter the all mandatory fields...');
              return;
            }
          }
        }
        fieldData.reasonForCapaCode = this.pushedReasonForChange.toString();
      } else {
        fieldData.reasonForCapaCode = null;
      }

      if (this.qmsCapaFieldData.expectedToBeStartedOn) {
        fieldData.expectedToBeStartedOn = new Date(this.qmsCapaFieldData.expectedToBeStartedOn);
        fieldData.expectedToBeStartedOn = this.appService.dateZoneConvertion(fieldData.expectedToBeStartedOn);
      } else {
        fieldData.expectedToBeStartedOn = null;
      }

      if (this.qmsCapaFieldData.expcetedClosureOn) {
        fieldData.expcetedClosureOn = new Date(this.qmsCapaFieldData.expcetedClosureOn);
        fieldData.expcetedClosureOn = this.appService.dateZoneConvertion(fieldData.expcetedClosureOn);
      } else {
        fieldData.expcetedClosureOn = null;
      }

      let data = {
        groupId: this.selectedGroupValue[0].valueExp,
        capaId: null,
        capaNo: null,
        deptCode: fieldData.deptCode,
        owner: fieldData.owner,
        capaType: fieldData.capaType,
        requestedAt: fieldData.requestedAt,
        coreBusinessAreaName: fieldData.coreBusinessAreaName,
        reasonForCapa: fieldData.reasonForCapa,
        reasonForCapaCode: fieldData.reasonForCapaCode,
        expcetedClosureOn: fieldData.expcetedClosureOn,
        expectedToBeStartedOn: fieldData.expectedToBeStartedOn,
        effectivenessCheckReqd: fieldData.effectivenessCheckReqd ? "Y" : "N",
        isRiskCalculationReqd: fieldData.isRiskCalculationReqd ? "Y" : "N",
        shortDescription: fieldData.shortDescription,
        capaDescription: fieldData.capaDescription
      }

      this.appService.createCapa(data).subscribe({
        next: (Response: any) => {
          this.message.lastmsg = Response;
          if (Response.resultType == 'S') {
            this.getCall();
            this.qualityService.activityId = Response.ID;
            this.qualityService.newlyAddedCapaDataFromAu = Response.ID;
            this.qualityService.capaIdForFindingReference = Response.capaIdForFindingReference;
            if (this.flexibleComponent.flexibleFields.length) { this.flexibleComponent.save('Master', +Response.ID); }
            this.visibleCapaAddPopup.close();
            this.showSnackBar(Response.result, Response.resultType);
            this.isProcessing = false;
          }
          this.isProcessing = false;
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });

    }
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
  }

  capaCancelPopupFuntion() {
    this.qualityService.activityId = null;
    this.selectedCapaDepartmentValue = null;
    this.selectedCapaOwnerValue = null;
    this.selectedCapaTypeValue = null;
    this.selectedCapaRequestedAtValue = null;
    this.selectedCapaCoreBusinessAreaNameValue = [];
    this.selectedReasonForCapaValue = [];
    this.qmsCapaFieldData.expcetedClosureOn = null;
    this.qmsCapaFieldData.shortDescription = "";
    this.qmsCapaFieldData.capaDescription = "";
    this.qmsCapaFieldData.effectivenessCheckReqd = false;
    this.visibleCapaAddPopup.close();
  }


  @Output() valueEmitter = new EventEmitter<string>();
  /* Start - Deviation */
  @ViewChild('dvAddPopup', { static: true }) dvAddPopup: TemplateRef<any>;
  visibleDvAddPopup: MatDialogRef<TemplateRef<any>>;

  qmsDvFieldData: any = {};
  selectedDvDepartmentValue: any = null;
  dvDepartmentCodeDropdown: any = [];
  selectedDvOwnerValue: any = null;
  dvOwnersListDropdown: any = [];
  selectedDvTypeValue: any = null;
  dvTypeDropdown: any = [];
  dvRequestedAtValue: any = null;
  dvRequestedAtDropdown: any = [];
  dvCoreBusinessAreaNameValue: any = [];
  dvCoreBusinessAreaNameDropdown: any = [];
  reasonForDeviationValue: any = [];
  reasonForDeviationDropdown: any = [];

  selectBoxForDvDepartmentCode() {
    this.dvDepartmentCodeDropdown = [];
    for (const element of this.dropDownForDepartmentCode) {
      this.dvDepartmentCodeDropdown = this.dvDepartmentCodeDropdown.concat({
        valueExp: element.codelistCode,
        displayExp: element.codelistName
      });
    }
  }

  selectBoxForDvOwnersList() {
    const groupOwner = this.qualityService.selectedGroupDetailData.isGroupOwnerRequired == 'Y';
    const owners = this.listOfOwnerUsers?.map((owner: any) => ({
      valueExp: owner.userId,
      displayExp: owner.userName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []

    this.dvOwnersListDropdown = groupOwner ? [{ valueExp: 100, displayExp: 'Group Owners' }, ...owners] : owners;
  }

  selectBoxForDeviationType() {
    this.dvTypeDropdown = [];
    this.dvTypeDropdown = this.dropDownForChangeType?.map((item: any) => ({
      valueExp: item.type,
      displayExp: item.type
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) || []
  }

  selectBoxForDvRequestedAt() {
    this.dvRequestedAtDropdown = [];
    this.filteredRequestedAtValue = this.getQmsBusinessAreaDetail.filter((x: any) => x.module === this.message.changeRequestCode);
    for (const element of this.filteredRequestedAtValue) {
      this.dvRequestedAtDropdown = this.dvRequestedAtDropdown.concat({
        valueExp: element.taskRequestedAt,
        displayExp: element.taskRequestedAt
      });
    }
  }

  selectBoxForDvCoreBusinessAreaName() {
    this.dvCoreBusinessAreaNameDropdown = [];
    for (let i = 0; i < this.filteredBusinessAreaValue?.length; i++) {
      this.dvCoreBusinessAreaNameDropdown = this.dvCoreBusinessAreaNameDropdown.concat({
        valueExp: this.filteredBusinessAreaValue[i],
        displayExp: this.filteredBusinessAreaValue[i]
      });
    }
  }

  setDvReason() {
    this.reasonForDeviationDropdown = [];
    for (const element of this.getReasonForChangeListValues) {
      this.reasonForDeviationDropdown = this.reasonForDeviationDropdown.concat({
        valueExp: element.codelistCode,
        displayExp: element.codelistName
      });
    }
  }

  onDvDepartmentCodeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (this.dvDepartmentFieldValue != undefined) {
          this.dvDepartmentFieldValue.style.color = '#005c8a';
        }
      } else {
        this.dvDepartmentFieldValue = document.getElementById('dvDepartment-validation') as HTMLInputElement;
        if (this.dvDepartmentFieldValue != undefined) {
          this.dvDepartmentFieldValue.style.color = 'red';
        }
      }
    }
  }

  onDvOwnerSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        if (this.dvOwnerFieldValue != undefined) {
          this.dvOwnerFieldValue.style.color = '#005c8a';
        }
      } else {

        this.dvOwnerFieldValue = document.getElementById('dvOwner-validation') as HTMLInputElement;
        if (this.dvOwnerFieldValue != undefined) {
          this.dvOwnerFieldValue.style.color = 'red';
        }
      }
    }
  }

  showDvTypeIfNa: boolean = false;
  onDvTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.isProcessing = true;
        this.dvExpcetedStartedOnFieldValue = document.getElementById('expectedToBeStartedOn-validation') as HTMLInputElement;
        this.dvExpcetedClosureOnFieldValue = document.getElementById('dvExpcetedClosureOn-validation') as HTMLInputElement;
        if (item.valueExp == 'NA') {
          this.showDvTypeIfNa = true;
        } else {
          this.appService.getTypeSettingsByType(this.qualityService.selectedActivityGroupId, this.qualityService.selectedGroupDetailId, item.valueExp).subscribe((response: any) => {
            if (response) {
              if (response.toBeStartedInDays) {
                let date = new Date();
                date.setDate(date.getDate() + response.toBeStartedInDays);
                this.qmsDvFieldData.expectedToBeStartedOn = date;
                this.dvExpcetedStartedOnFieldValue.style.color = '#005c8a';
              } else {
                this.qmsDvFieldData.expectedToBeStartedOn = null;
              }

              if (response.toBeClosedInDays) {
                let date = new Date();
                this.qmsDvFieldData.expectedToBeStartedOn == null ? date.setDate(date.getDate() + response.toBeClosedInDays) : date.setDate(date.getDate() + response.toBeStartedInDays + response.toBeClosedInDays);
                this.qmsDvFieldData.expcetedClosureOn = date;
                this.dvExpcetedClosureOnFieldValue.style.color = '#005c8a';
              } else {
                this.qmsDvFieldData.expcetedClosureOn = null;
              }
            }

            this.isProcessing = false;
          })
          this.showDvTypeIfNa = false;
        }
      } else {
        this.showDvTypeIfNa = false;
      }
    }
  }

  onDvRequestedAtSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.dvCoreBusinessAreaNameDropdown = [];
        this.dvCoreBusinessAreaNameValue = [];

        this.bussinessAreaName = item.displayExp;
        let businessAreaValues = this.filteredRequestedAtValue.filter((x: any) => x.taskRequestedAt === item.displayExp);
        if (businessAreaValues.length != 0) {
          this.filteredBusinessAreaValue = businessAreaValues[0].listOfBusinessArea?.split(',');
          this.selectBoxForDvCoreBusinessAreaName();
        }

        if (this.dvRequestedAtFieldValue != undefined) {
          this.dvRequestedAtFieldValue.style.color = '#005c8a';
        }
      } else {
        this.dvRequestedAtFieldValue = document.getElementById('dvRequestedAt-validation') as HTMLInputElement;
        if (this.dvRequestedAtFieldValue != undefined) {
          this.dvRequestedAtFieldValue.style.color = 'red';
        }

        if (this.dvRequestedAtValue.length == 0) {
          this.dvCoreBusinessAreaNameValue = [];
          this.dvCoreBusinessAreaNameDropdown = [];
          this.bussinessAreaName = undefined;
        }
      }
      setTimeout(() => { this.flexibleComponent.triggerFromRequestedAt(item.valueExp) })
    }
  }

  onDvCoreBusinessAreaNameSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectCoreBusinessAreaNameValueExp = item.valueExp;
        setTimeout(() => {
          this.allcoreBusinesssSelectedDv = this.dvCoreBusinessAreaNameDropdown.length == this.dvCoreBusinessAreaNameValue.length;
        });
        if (this.dvCoreBusinessAreaFieldValue != undefined) {
          this.dvCoreBusinessAreaFieldValue.style.color = '#005c8a';
        }
      } else {

        this.allcoreBusinesssSelectedDv = false;
        this.dvCoreBusinessAreaFieldValue = document.getElementById('dvCoreBusinessArea-validation') as HTMLInputElement;
        if (this.coreBusinessAreaNameValue.length == 0) {
          if (this.dvCoreBusinessAreaFieldValue != undefined) {
            this.dvCoreBusinessAreaFieldValue.style.color = 'red';
          }
        }
      }

    }
  }

  onDvCoreBusinessAreaNameSelectAll(item: any) {
    this.selectCoreBusinessAreaNameValueExp = [];
    for (const element of item) {
      this.selectCoreBusinessAreaNameValueExp.push({
        valueExp: element.valueExp,
      });
    }
    if (this.dvCoreBusinessAreaFieldValue != undefined) {
      this.dvCoreBusinessAreaFieldValue.style.color = '#005c8a';
    }
  };

  onDvCoreBusinessAreaNameDeSelectAll(item: any) {
    this.dvCoreBusinessAreaFieldValue = document.getElementById('dvCoreBusinessArea-validation') as HTMLInputElement;
    this.selectCoreBusinessAreaNameValueExp = [];
    if (this.dvCoreBusinessAreaFieldValue != undefined) {
      this.dvCoreBusinessAreaFieldValue.style.color = 'red';
    }
  };

  selectedReasonForDvValueExp: any = [];
  visibleReasonForDivationIfOthers: boolean = false;
  onReasonForDeviationSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.reasonForCapaFieldValue = document.getElementById('reasonForDeviation-validation') as HTMLInputElement;
        this.selectedReasonForDvValueExp = item.valueExp;
        if (item.valueExp == 'Others') {
          this.visibleReasonForDivationIfOthers = true;
        }
        if (this.reasonForCapaFieldValue != undefined) {
          this.reasonForCapaFieldValue.style.color = '#005c8a';
        }
      } else {
        this.reasonForCapaFieldValue = document.getElementById('reasonForDeviation-validation') as HTMLInputElement;
        if (item.valueExp == 'Others') {
          this.visibleReasonForDivationIfOthers = false;
          this.qmsDvFieldData.reasonForDeviation = '';
        } else if (this.reasonForDeviationValue.length == 0) {
          this.selectedReasonForDvValueExp = [];
          if (this.reasonForCapaFieldValue != undefined) {
            this.reasonForCapaFieldValue.style.color = 'red';
          }
        }
      }
      setTimeout(() => {
        this.allSelectedDv = this.reasonForDeviationDropdown.length == this.reasonForDeviationValue.length;
      });
    }
  }

  onReasonForDeviationSelectAll(item: any) {
    console.log(item.valueExp);
    this.reasonForCapaFieldValue = document.getElementById('reasonForDeviation-validation') as HTMLInputElement;
    this.selectedReasonForDvValueExp = [];
    for (const element of item) {
      this.selectedReasonForDvValueExp.push({
        valueExp: element.valueExp,
      });
    }
    if (this.reasonForCapaFieldValue != undefined) {
      this.reasonForCapaFieldValue.style.color = '#005c8a';
    }
  }

  onReasonForDeviationDeSelectAll(item: any) {
    console.log(item.valueExp);
    this.reasonForCapaFieldValue = document.getElementById('reasonForDeviation-validation') as HTMLInputElement;
    this.visibleReasonForDivationIfOthers = false;
    this.selectedReasonForDvValueExp = [];
    this.qmsDvFieldData.reasonForDeviation = '';
    if (this.reasonForCapaFieldValue != undefined) {
      this.visibleReasonForDivationIfOthers = false
      this.reasonForCapaFieldValue.style.color = 'red';
    }
  }

  commonDateConfig = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }

  $present_future_config = {
    ...this.commonDateConfig,
    minDate: new Date()
  }

  $past_present_config = {
    ...this.commonDateConfig,
    maxDate: new Date()
  }

  $identified_on_dynamic_config() {
    return {
      ...this.commonDateConfig,
      ...this.qualityService.moduleName == 'DV' && { minDate: this.qmsDvFieldData.deviationOccuredOn ? new Date(this.qmsDvFieldData.deviationOccuredOn) : new Date() },
      ...this.qualityService.moduleName == 'OOS' && { minDate: this.oos.dateOfOccurrence ? new Date(this.oos.dateOfOccurrence) : new Date() },
      maxDate: new Date()
    }
  }

  changedDeviationOccuredOnDate(items: any) {
    if (this.qmsDvFieldData.deviationIdentifiedOn && (this.qmsDvFieldData.deviationOccuredOn < this.qmsDvFieldData.deviationIdentifiedOn)) this.qmsDvFieldData.deviationIdentifiedOn = null;
    this.deviationOccuredOnFieldValue = document.getElementById('deviationOccuredOn-validation') as HTMLInputElement;
    if (items != null || items != undefined) {
      this.deviationOccuredOnFieldValue.style.color = '#005c8a';
    } else {
      this.deviationOccuredOnFieldValue.style.color = 'red';
    }
  }

  onOosOccurrenceChange(items: any) {
    if (this.oos.identifiedOn && (this.oos.dateOfOccurrence > this.oos.identifiedOn)) this.oos.identifiedOn = null;
  }

  changeDeviationIdentifiedOnDate(items: any) {
    this.deviationIdentifiedOnFieldValue = document.getElementById('deviationIdentifiedOn-validation') as HTMLInputElement;
    if (items != null || items != undefined) {
      this.deviationIdentifiedOnFieldValue.style.color = '#005c8a';
    } else {
      this.deviationIdentifiedOnFieldValue.style.color = 'red';
    }
  }

  changeDvExpectedToBeStartedOnDate(items: any) {
    this.dvExpcetedStartedOnFieldValue = document.getElementById('expectedToBeStartedOn-validation') as HTMLInputElement;
    if (items != null || items != undefined) {
      this.dvExpcetedStartedOnFieldValue.style.color = '#005c8a';
    } else {
      this.dvExpcetedStartedOnFieldValue.style.color = 'red';
    }
  }

  changeDvExpcetedClosureOnDate(items: any) {
    this.dvExpcetedClosureOnFieldValue = document.getElementById('dvExpcetedClosureOn-validation') as HTMLInputElement;
    if (items != null || items != undefined) {
      this.dvExpcetedClosureOnFieldValue.style.color = '#005c8a';
    } else {
      this.dvExpcetedClosureOnFieldValue.style.color = 'red';
    }
  }

  openDvAddPopup() {
    this.qualityService.activityId = null;
    this.selectedDvDepartmentValue = null;
    this.selectedDvOwnerValue = null;
    this.selectedDvTypeValue = null;
    this.dvRequestedAtValue = null;
    this.dvCoreBusinessAreaNameValue = [];
    this.dvCoreBusinessAreaNameDropdown = [];
    this.reasonForDeviationValue = [];
    this.qmsDvFieldData.deviationOccuredOn = null;
    this.qmsDvFieldData.deviationIdentifiedOn = null;
    this.qmsDvFieldData.expectedToBeStartedOn = null;
    this.qmsDvFieldData.expcetedClosureOn = null;
    this.qmsDvFieldData.effectivenessCheckReqd = false;
    this.qmsDvFieldData.shortDescription = "";
    this.qmsDvFieldData.reasonForDeviation = "";
    this.qmsDvFieldData = {};
    this.qmsDvFieldData.dvDescription = "";
    if (this.qualityService.selectedGroupDetailData.isRiskCalculationReqd == 'Y') {
      this.qmsDvFieldData.isRiskCalculationReqd = true;
    } else {
      this.qmsDvFieldData.isRiskCalculationReqd = false;
    }

    this.visibleReasonForDivationIfOthers = false;
    this.bussinessAreaName = undefined;
    this.popupDataTitle.title = "Create " + this.qualityService.moduleFullName;;
    this.visibleDvAddPopup = this.dialog.open(this.dvAddPopup, this.addAndEditPopupConfig);
  }

  dvDepartmentFieldValue: any;
  dvOwnerFieldValue: any;
  dvRequestedAtFieldValue: any;
  dvCoreBusinessAreaFieldValue: any;
  reasonForDeviation: any;
  deviationOccuredOnFieldValue: any;
  deviationIdentifiedOnFieldValue: any;
  dvExpcetedStartedOnFieldValue: any;
  dvExpcetedClosureOnFieldValue: any;
  dvShortDescription: any;
  dvDescriptionFieldValue: any;
  dvFieldValidation() {
    this.dvDepartmentFieldValue = document.getElementById('dvDepartment-validation') as HTMLInputElement;
    this.dvOwnerFieldValue = document.getElementById('dvOwner-validation') as HTMLInputElement;
    this.dvRequestedAtFieldValue = document.getElementById('dvRequestedAt-validation') as HTMLInputElement;
    this.dvCoreBusinessAreaFieldValue = document.getElementById('dvCoreBusinessArea-validation') as HTMLInputElement;
    this.reasonForDeviation = document.getElementById('reasonForDeviation-validation') as HTMLInputElement;
    this.deviationOccuredOnFieldValue = document.getElementById('deviationOccuredOn-validation') as HTMLInputElement;
    this.deviationIdentifiedOnFieldValue = document.getElementById('deviationIdentifiedOn-validation') as HTMLInputElement;
    this.dvExpcetedStartedOnFieldValue = document.getElementById('expectedToBeStartedOn-validation') as HTMLInputElement;
    this.dvExpcetedClosureOnFieldValue = document.getElementById('dvExpcetedClosureOn-validation') as HTMLInputElement;
    this.dvShortDescription = document.getElementById('dvShortDescription-validation') as HTMLInputElement;
    this.dvDescriptionFieldValue = document.getElementById('dvDescription-validation') as HTMLInputElement;

    if (this.selectedDvDepartmentValue == null) {
      this.dvDepartmentFieldValue.style.color = 'red';
    } else {
      this.dvDepartmentFieldValue.style.color = '#005c8a';
    }

    if (this.selectedDvOwnerValue == null) {
      this.dvOwnerFieldValue.style.color = 'red';
    } else {
      this.dvOwnerFieldValue.style.color = '#005c8a';
    }

    if (this.dvRequestedAtValue == null) {
      this.dvRequestedAtFieldValue.style.color = 'red';
    } else {
      this.dvRequestedAtFieldValue.style.color = '#005c8a';
    }

    if (this.dvRequestedAtValue) {
      if (this.dvCoreBusinessAreaFieldValue) {
        if (this.dvCoreBusinessAreaNameValue.length == 0) {
          this.dvCoreBusinessAreaFieldValue.style.color = 'red';
        }
      } else if (this.dvCoreBusinessAreaNameValue.length == 0) {
        this.dvCoreBusinessAreaFieldValue.style.color = 'red';
      } else {
        this.dvCoreBusinessAreaFieldValue.style.color = '#005c8a';
      }
    }

    if (this.dynamicLabel['REASON_FOR_DEVIATION_CODE'].isRemovable !== 'Y' && !this.reasonForDeviationValue?.length) {
      this.reasonForDeviation.style.color = 'red';
    } else {
      this.reasonForDeviation.style.color = '#005c8a';
    }

    if (this.dynamicLabel?.['DEVIATION_OCCURED_ON']?.isRemovable !== 'Y' && (this.qmsDvFieldData.deviationOccuredOn == null || this.qmsDvFieldData.deviationOccuredOn == undefined)) {
      this.deviationOccuredOnFieldValue.style.color = 'red';
    } else {
      this.deviationOccuredOnFieldValue.style.color = '#005c8a';
    }

    if (this.dynamicLabel?.['DEVIATION_IDENTIFIED_ON']?.isRemovable !== 'Y' && (this.qmsDvFieldData.deviationIdentifiedOn == null || this.qmsDvFieldData.deviationIdentifiedOn == undefined)) {
      this.deviationIdentifiedOnFieldValue.style.color = 'red';
    } else {
      this.deviationIdentifiedOnFieldValue.style.color = '#005c8a';
    }

    if (this.qmsDvFieldData.expectedToBeStartedOn == null || this.qmsDvFieldData.expectedToBeStartedOn == undefined) {
      this.dvExpcetedStartedOnFieldValue.style.color = 'red';
    } else {
      this.dvExpcetedStartedOnFieldValue.style.color = '#005c8a';
    }

    if (this.qmsDvFieldData.expcetedClosureOn == null || this.qmsDvFieldData.expcetedClosureOn == undefined) {
      this.dvExpcetedClosureOnFieldValue.style.color = 'red';
    } else {
      this.dvExpcetedClosureOnFieldValue.style.color = '#005c8a';
    }

    if (this.qmsDvFieldData.shortDescription == "" || this.qmsDvFieldData.shortDescription == undefined) {
      this.dvShortDescription.style.color = 'red';
    } else {
      this.dvShortDescription.style.color = '#005c8a';
    }

    if (this.qmsDvFieldData.dvDescription == "" || this.qmsDvFieldData.dvDescription == undefined) {
      this.dvDescriptionFieldValue.style.color = 'red';
    } else {
      this.dvDescriptionFieldValue.style.color = '#005c8a';
    }

  }

  onDvFieldFocusout() {
    this.dvShortDescription = document.getElementById('dvShortDescription-validation') as HTMLInputElement;
    this.dvDescriptionFieldValue = document.getElementById('dvDescription-validation') as HTMLInputElement;

    if (this.dvShortDescription != undefined) {
      if (this.qmsDvFieldData.shortDescription == "" || this.qmsDvFieldData.shortDescription == undefined) {
        this.dvShortDescription.style.color = 'red';
      } else {
        this.dvShortDescription.style.color = '#005c8a';
      }
    } else if (this.qmsDvFieldData.shortDescription == "" || this.qmsDvFieldData.shortDescription == undefined) {
      this.dvShortDescription.style.color = 'red';
    } else {
      this.dvShortDescription.style.color = '#005c8a';
    }

    if (this.dvDescriptionFieldValue != undefined) {
      if (this.qmsDvFieldData.dvDescription == "" || this.qmsDvFieldData.dvDescription == undefined) {
        this.dvDescriptionFieldValue.style.color = 'red';
      } else {
        this.dvDescriptionFieldValue.style.color = '#005c8a';
      }
    } else if (this.qmsDvFieldData.dvDescription == "" || this.qmsDvFieldData.dvDescription == undefined) {
      this.dvDescriptionFieldValue.style.color = 'red';
    } else {
      this.dvDescriptionFieldValue.style.color = '#005c8a';
    }

  }

  dvSaveButtonFuntion(fieldData: any) {
    this.isProcessing = true;
    this.reasonForChangeIfOthersFieldValue = document.getElementById('reasonForChangeIfOthers-validation') as HTMLInputElement;

    console.log(fieldData);

    const validations = [
      {
        condition: !this.selectedDvDepartmentValue && this.dynamicLabel['DEPT_NAME'].isRemovable !== 'Y',
        id: 'dvDepartment-validation'
      },
      {
        condition: !this.selectedDvOwnerValue,
        id: 'dvOwner-validation'
      },
      {
        condition: !this.dvRequestedAtValue,
        id: 'dvRequestedAt-validation'
      },
      {
        condition: !this.dvCoreBusinessAreaNameValue?.length,
        id: 'dvCoreBusinessArea-validation'
      },
      {
        condition: !this.qmsDvFieldData.deviationCriticality && this.dynamicLabel['DEVIATION_CRITICALITY'].isRemovable != 'Y',
        id: 'dv-criticality'
      },
      {
        condition: this.dynamicLabel['REASON_FOR_DEVIATION_CODE'].isRemovable !== 'Y' && !this.reasonForDeviationValue?.length,
        id: 'reasonForDeviation-validation'
      },
      {
        condition: this.dynamicLabel?.['DEVIATION_OCCURED_ON']?.isRemovable !== 'Y' && !fieldData.deviationOccuredOn,
        id: 'deviationOccuredOn-validation'
      },
      {
        condition: this.dynamicLabel?.['DEVIATION_IDENTIFIED_ON']?.isRemovable !== 'Y' && !fieldData.deviationIdentifiedOn,
        id: 'deviationIdentifiedOn-validation'
      },
      {
        condition: !fieldData.expectedToBeStartedOn && this.dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].isRemovable !== 'Y',
        id: 'expectedToBeStartedOn-validation'
      },
      {
        condition: !fieldData.expcetedClosureOn,
        id: 'dvExpcetedClosureOn-validation'
      },
      {
        condition: !fieldData.shortDescription,
        id: 'dvShortDescription-validation'
      },
      {
        condition: !fieldData.dvDescription,
        id: 'dvDescription-validation'
      }
    ];
    const invalidIds = validations.filter((validation) => validation.condition).map((validation) => validation.id);

    if (invalidIds.length > 0) {
      this.mandatoryValidation(invalidIds);
      this.visibleMandatoryPopup = this.dialog.open(this.mandatoryPopup, this.mandatoryPopupConfig);
      this.isProcessing = false;
    }
    else {
      delete fieldData.createdOn;
      delete fieldData.updatedOn;

      if (this.selectedDvDepartmentValue) {
        fieldData.deptCode = this.selectedDvDepartmentValue;
      } else {
        fieldData.deptCode = null;
      }

      if (this.selectedDvOwnerValue) {
        fieldData.owner = this.selectedDvOwnerValue;
      } else {
        fieldData.owner = null;
      }

      if (this.selectedDvTypeValue) {
        fieldData.deviationType = this.selectedDvTypeValue;
      } else {
        fieldData.deviationType = null;
      }

      if (this.dvRequestedAtValue) {
        fieldData.requestedAt = this.dvRequestedAtValue;
      } else {
        fieldData.requestedAt = null;
      }

      if (this.dvCoreBusinessAreaNameDropdown.length > 0) {
        fieldData.coreBusinessAreaName = '';
        if (this.dvCoreBusinessAreaNameValue.length) {
          for (let j = 0; j < this.dvCoreBusinessAreaNameValue.length; j++) {
            fieldData.coreBusinessAreaName += this.dvCoreBusinessAreaNameValue[j];
            fieldData.coreBusinessAreaName += j == this.dvCoreBusinessAreaNameValue.length - 1 ? "" : ",";
          }
        } else {
          fieldData.coreBusinessAreaName = null;
        }
      } else {
        fieldData.coreBusinessAreaName = this.dvCoreBusinessAreaNameValue;
      }


      this.pushedReasonForChange = [];
      if (this.reasonForDeviationValue != undefined || this.reasonForDeviationValue.length != 0) {
        for (const element of this.reasonForDeviationValue) {
          this.pushedReasonForChange.push(element);
          if (element == 'Others') {
            if (fieldData.reasonForDeviation == undefined || fieldData.reasonForDeviation == '') {
              this.reasonForChangeIfOthersFieldValue.style.color = 'red';
              this.isProcessing = false;
              alert('Please enter the all mandatory fields...');
              return;
            }
          }
        }
        fieldData.reasonForDeviationCode = this.pushedReasonForChange.toString();
      } else {
        fieldData.reasonForDeviationCode = null;
      }

      if (this.qmsDvFieldData.deviationOccuredOn) {
        fieldData.deviationOccuredOn = new Date(this.qmsDvFieldData.deviationOccuredOn);
        fieldData.deviationOccuredOn = this.appService.dateZoneConvertion(fieldData.deviationOccuredOn);
      } else {
        fieldData.deviationOccuredOn = null;
      }

      if (this.qmsDvFieldData.deviationIdentifiedOn) {
        fieldData.deviationIdentifiedOn = new Date(this.qmsDvFieldData.deviationIdentifiedOn);
        fieldData.deviationIdentifiedOn = this.appService.dateZoneConvertion(fieldData.deviationIdentifiedOn);
      } else {
        fieldData.deviationIdentifiedOn = null;
      }

      if (this.qmsDvFieldData.expectedToBeStartedOn) {
        fieldData.expectedToBeStartedOn = new Date(this.qmsDvFieldData.expectedToBeStartedOn);
        fieldData.expectedToBeStartedOn = this.appService.dateZoneConvertion(fieldData.expectedToBeStartedOn);
      } else {
        fieldData.expectedToBeStartedOn = null;
      }

      if (this.qmsDvFieldData.expcetedClosureOn) {
        fieldData.expcetedClosureOn = new Date(this.qmsDvFieldData.expcetedClosureOn);
        fieldData.expcetedClosureOn = this.appService.dateZoneConvertion(fieldData.expcetedClosureOn);
      } else {
        fieldData.expcetedClosureOn = null;
      }

      let data = {
        groupId: this.selectedGroupValue[0].valueExp,
        deptCode: fieldData.deptCode,
        owner: fieldData.owner,
        deviationType: fieldData.deviationType,
        requestedAt: fieldData.requestedAt,
        coreBusinessAreaName: fieldData.coreBusinessAreaName,
        reasonForDeviation: fieldData.reasonForDeviation,
        reasonForDeviationCode: fieldData.reasonForDeviationCode,
        deviationOccuredOn: fieldData.deviationOccuredOn,
        deviationIdentifiedOn: fieldData.deviationIdentifiedOn,
        expcetedClosureOn: fieldData.expcetedClosureOn,
        expectedToBeStartedOn: fieldData.expectedToBeStartedOn,
        effectivenessCheckReqd: fieldData.effectivenessCheckReqd ? "Y" : "N",
        isRiskCalculationReqd: fieldData.isRiskCalculationReqd ? "Y" : "N",
        shortDescription: fieldData.shortDescription,
        dvDescription: fieldData.dvDescription,
        deviationCriticality: fieldData.deviationCriticality
      }

      this.appService.createDv(data).subscribe({
        next: (Response: any) => {
          this.message.lastmsg = Response;
          if (Response.resultType == 'S') {
            this.getCall();
            this.qualityService.activityId = Response.ID;
            if (this.flexibleComponent.flexibleFields.length) { this.flexibleComponent.save('Master', +Response.ID); }
            this.isProcessing = false;
            this.visibleDvAddPopup.close();
          }
          this.showSnackBar(Response.result, Response.resultType);
          this.isProcessing = false;
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  dvCancelPopupFuntion() {
    this.visibleDvAddPopup.close();
  }

  /* Quality Issue */
  @ViewChild('qiAddPopup', { static: true }) qiAddPopup: TemplateRef<any>;
  visibleQiAddPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('mandatoryPopup', { static: true }) mandatoryPopup: TemplateRef<any>;
  visibleMandatoryPopup: MatDialogRef<TemplateRef<any>>;

  mandatoryPopupConfig = {
    width: '400px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  qmsQiFieldData: any = {};

  identifiedOnConfig = {
    ...this.commonDateConfig,
    maxDate: new Date()
  }

  expectedToBeStartedOnConfig = {
    ...this.commonDateConfig,

    ...(this.qualityService.moduleName == 'CR') && { minDate: new Date() },
    ...(this.qualityService.moduleName == 'CAPA') && { minDate: new Date() },
    ...(this.qualityService.moduleName == 'DV') && { minDate: new Date() },
    ...(this.qualityService.moduleName == 'QI') && { minDate: new Date() },
    ...(this.qualityService.moduleName == 'OOS') && { minDate: new Date() },
  }

  onExpectedToBeStartedOnChange() {
    if (this.qualityService.moduleName == 'CR' && this.qmsCRData.expcetedClosureOn && (this.qmsCRData.expcetedClosureOn < this.qmsCRData.expectedToBeStartedOn)) this.qmsCRData.expcetedClosureOn = null;
    if (this.qualityService.moduleName == 'CAPA' && this.qmsCapaFieldData.expcetedClosureOn && (this.qmsCapaFieldData.expcetedClosureOn < this.qmsCapaFieldData.expectedToBeStartedOn)) this.qmsCapaFieldData.expcetedClosureOn = null;
    if (this.qualityService.moduleName == 'DV' && this.qmsDvFieldData.expcetedClosureOn && (this.qmsDvFieldData.expcetedClosureOn < this.qmsDvFieldData.expectedToBeStartedOn)) this.qmsDvFieldData.expcetedClosureOn = null;
    if (this.qualityService.moduleName == 'QI' && this.qmsQiFieldData.expcetedClosureOn && (this.qmsQiFieldData.expcetedClosureOn < this.qmsQiFieldData.expectedToBeStartedOn)) this.qmsQiFieldData.expcetedClosureOn = null;
    if (this.qualityService.moduleName == 'OOS' && this.oos.expcetedClosureOn && (this.oos.expcetedClosureOn < this.oos.expectedToBeStartedOn)) this.oos.expcetedClosureOn = null;
  }

  generateExpectedClosureDateConfig() {
    return {
      ...this.commonDateConfig,
      ...(this.qualityService.moduleName == 'CR') && { minDate: this.qmsCRData.expectedToBeStartedOn ? new Date(this.qmsCRData.expectedToBeStartedOn) : new Date() },
      ...(this.qualityService.moduleName == 'CAPA') && { minDate: this.qmsCapaFieldData.expectedToBeStartedOn ? new Date(this.qmsCapaFieldData.expectedToBeStartedOn) : new Date() },
      ...(this.qualityService.moduleName == 'DV') && { minDate: this.qmsDvFieldData.expectedToBeStartedOn ? new Date(this.qmsDvFieldData.expectedToBeStartedOn) : new Date() },
      ...(this.qualityService.moduleName == 'QI') && { minDate: this.qmsQiFieldData.expectedToBeStartedOn ? new Date(this.qmsQiFieldData.expectedToBeStartedOn) : new Date() },
      ...(this.qualityService.moduleName == 'OOS') && { minDate: this.oos.expectedToBeStartedOn ? new Date(this.oos.expectedToBeStartedOn) : new Date() },
    }
  }

  selectedQiType: any = null
  selectedQiDepartment: any = null
  selectedQiReference: any = null
  selectedQiRequestedAtValue: any = null
  selectedQiCoreBusinessAreaNameValue: any = [] as string[] | string;
  selectedQiEvaluator: any = null
  selectedQiImpactType: any = null

  dropDownForQiReference: any = [];
  dropDownForQiEvaluator: any = [];
  dropDownForQiImpactType: any = [];

  qiTypeDropdown: any = [];
  qiDepartmentCodeDropdown: any = [];
  qiReferenceDropDown: any = [];
  qiRequestedAtDropdown: any = [];
  qiCoreBusinessAreaNameDropdown: any = [];
  qiEvaluatorDropDown: any = [];
  qiImpactTypeDropDown: any = [];

  selectBoxForQiType() {
    this.qiTypeDropdown = [];
    this.qiTypeDropdown = this.dropDownForChangeType?.map((item: any) => ({
      valueExp: item.type,
      displayExp: item.type
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) || []
  }

  onQiTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('qi-type-validation', item);

      if (item) {
        this.isProcessing = true;
        this.selectedQiTypeCodeValueExp = item.valueExp;
        if (item.valueExp == 'NA') {
          this.showChangeTypeIfNa = true;
        } else {
          this.appService.getTypeSettingsByType(this.qualityService.selectedActivityGroupId, this.qualityService.selectedGroupDetailId, item.valueExp).subscribe((response: any) => {
            if (response != null) {
              if (response.toBeStartedInDays) {
                let date = new Date();
                date.setDate(date.getDate() + response.toBeStartedInDays);
                this.qmsQiFieldData.expectedToBeStartedOn = date;
                this.onNgModuleChange(this.qmsQiFieldData.expectedToBeStartedOn, 'qi-expected-to-be-started-on-validation')
              } else {
                this.qmsQiFieldData.expectedToBeStartedOn = null;
              }

              if (response.toBeClosedInDays) {
                let date = new Date();
                this.qmsQiFieldData.expectedToBeStartedOn == null ? date.setDate(date.getDate() + response.toBeClosedInDays) : date.setDate(date.getDate() + response.toBeStartedInDays + response.toBeClosedInDays)
                this.qmsQiFieldData.expcetedClosureOn = date;
                this.onNgModuleChange(this.qmsQiFieldData.expcetedClosureOn, 'qi-expected-closure-on-validation')
              } else {
                this.qmsQiFieldData.expcetedClosureOn = null;
              }
            }
            this.isProcessing = false;
          })
          this.showChangeTypeIfNa = false;
        }
      }
    }
  }

  selectedQiTypeCodeValueExp: any;
  selectBoxForQiDepartmentCode() {
    this.qiDepartmentCodeDropdown = [];
    this.qiDepartmentCodeDropdown = this.dropDownForDepartmentCode?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim())) || []
  }

  onQiDepartmentSelect(event: any, item: any) {
    if (event.isUserInput)
      this.handleDropDownValidation('qi-department-validation', item);
  }

  selectBoxForQiReference() {
    this.qiReferenceDropDown = [];
    this.qiReferenceDropDown = this.dropDownForQiReference?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim())) || []
  }

  visibleReferenceIfOthers: any;
  onQiReferenceSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('qi-reference-validation', item);
      if (item) {
        if (item.displayExp == 'Others') [this.visibleReferenceIfOthers, this.qmsQiFieldData.referenceOthers] = [true, ''];
        else this.visibleReferenceIfOthers = false;
      }
    }
  }

  onQiReferenceDeselect(item: any) {
    this.handleDropDownValidation('qi-reference-validation', this.selectedQiReference);
    if (this.visibleReferenceIfOthers) [this.visibleReferenceIfOthers, this.qmsQiFieldData.referenceOthers] = [true, ''];
  }

  selectBoxForQiRequestedAt() {
    this.qiRequestedAtDropdown = [];
    this.qiRequestedAtDropdown = this.getQmsBusinessAreaDetail?.filter((data: any) => data.module === this.message.changeRequestCode)?.map((item: any) => ({
      valueExp: item.taskRequestedAt,
      displayExp: item.taskRequestedAt
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim())) || []
  }

  dropDownForQiCoreBusinessArea: any = [];
  isBusinessAreaEmpty: boolean = false;
  onQiRequestedAtSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('qi-requested-at-validation', item);
      if (item) {
        this.bussinessAreaName = item.displayExp;

        const businessArea = this.getQmsBusinessAreaDetail?.filter((data: any) => data.module === this.message.changeRequestCode)?.find((task: any) => task.taskRequestedAt == item.displayExp);
        this.isBusinessAreaEmpty = businessArea ? !businessArea.listOfBusinessArea : true;
        [this.qiCoreBusinessAreaNameDropdown, this.selectedQiCoreBusinessAreaNameValue] = [[], this.isBusinessAreaEmpty ? '' : []];

        if (!this.isBusinessAreaEmpty) {
          this.isAllQIBusinessAreaSelected = false;
          this.dropDownForQiCoreBusinessArea = businessArea.listOfBusinessArea.split(',');
          this.selectBoxForQiCoreBusinessArea();
        }
      }
      setTimeout(() => { this.flexibleComponent.triggerFromRequestedAt(item.valueExp) })
    }
  }

  selectBoxForQiCoreBusinessArea() {
    this.qiCoreBusinessAreaNameDropdown = [];
    this.qiCoreBusinessAreaNameDropdown = this.dropDownForQiCoreBusinessArea?.map((value: any) => ({
      valueExp: value,
      displayExp: value
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim())) || []
  }

  onQiCoreBusinessAreaSelect(event: any, item: any) {
    if (event.isUserInput)
      setTimeout(() => {
        this.handleDropDownValidation('qi-corebusiness-area-validation', this.selectedQiCoreBusinessAreaNameValue);
        this.isAllQIBusinessAreaSelected = this.qiCoreBusinessAreaNameDropdown.length == this.selectedQiCoreBusinessAreaNameValue.length;
      });
  }

  selectBoxForEvaluator() {
    this.qiEvaluatorDropDown = [];
    this.qiEvaluatorDropDown = this.dropDownForQiEvaluator?.map((item: any) => ({
      valueExp: item.userId,
      displayExp: item.userName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim())) || []
  }

  onEvaluatorSelect(event: any, item: any) {
    if (event.isUserInput)
      this.handleDropDownValidation('evaluator-validation', item);
  }

  selectBoxForQiImpactType() {
    this.qiImpactTypeDropDown = [];
    this.qiImpactTypeDropDown = this.dropDownForQiImpactType?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.trim().localeCompare(n.displayExp.trim())) || []
  }

  openQiAddPopup() {
    this.qualityService.activityId = null;
    [
      this.selectedQiType,
      this.selectedQiDepartment,
      this.selectedQiReference,
      this.selectedQiRequestedAtValue,
      this.selectedQiEvaluator,
      this.selectedQiImpactType
    ] = new Array().fill(null);
    [
      this.qmsQiFieldData.identifiedOn,
      this.qmsQiFieldData.expectedToBeStartedOn,
      this.qmsQiFieldData.expcetedClosureOn,
    ] = [null, null, null];
    [
      this.qmsQiFieldData.referenceOthers,
      this.qmsQiFieldData.impactDescription,
      this.qmsQiFieldData.shortDescription,
      this.qmsQiFieldData.description,
      this.selectedQiCoreBusinessAreaNameValue
    ] = ['', '', '', '', []];
    if (this.qualityService.selectedGroupDetailData.isRiskCalculationReqd == 'Y') {
      this.qmsQiFieldData.isRiskCalculationReqd = true;
    } else {
      this.qmsQiFieldData.isRiskCalculationReqd = false;
    }
    this.popupDataTitle.title = "Create " + this.qualityService.moduleFullName;;
    this.visibleQiAddPopup = this.dialog.open(this.qiAddPopup, this.addAndEditPopupConfig);
  }

  qiCancelPopupFuntion() {
    this.visibleQiAddPopup.close();
  }

  handleDropDownValidation(fieldId: string, selectedItems: any[] | string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isMultiSelectValidation = (fieldId === 'qi-corebusiness-area-validation');
    const shouldBeRed = isMultiSelectValidation ? !selectedItems.length : !selectedItems;

    field && (field.style.color = shouldBeRed ? 'red' : '#005c8a');
    !field && console.error('Unable to find the element. [handleDropDownValidation()] Id → ', fieldId);
  }

  onNgModuleChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;

    field && (field.style.color = items ? '#005c8a' : 'red');
    !field && console.error('Unable to find the element. [onNgModuleChange()] Id → ', fieldId);
  }

  mandatoryValidation(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;

      element && (element.style.color = 'red');
      !element && console.error('Unable to find the element. [mandatoryValidation()] Id → ', elementId);
    });
  }

  qiSave(qiData: any) {
    this.isProcessing = true;

    const validations = [
      { condition: (this.dynamicLabel['DEPT_NAME']?.isRemovable != 'Y' && !this.selectedQiDepartment), id: 'qi-department-validation' },
      { condition: (!this.selectedQiReference), id: 'qi-reference-validation' },
      { condition: (!this.selectedQiType), id: 'qi-type-validation' },
      { condition: (this.visibleReferenceIfOthers && !qiData.referenceOthers), id: 'qi-reference-others-validation' },
      { condition: (!this.selectedQiRequestedAtValue), id: 'qi-requested-at-validation' },
      { condition: (this.isBusinessAreaEmpty ? !this.selectedQiCoreBusinessAreaNameValue : !this.selectedQiCoreBusinessAreaNameValue.length), id: 'qi-corebusiness-area-validation' },
      { condition: (!this.selectedQiEvaluator), id: 'evaluator-validation' },
      { condition: (!qiData.identifiedOn), id: 'qi-identified-on-validation' },
      { condition: (this.dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].isRemovable != 'Y' && !qiData.expectedToBeStartedOn), id: 'qi-expected-to-be-started-on-validation' },
      { condition: (!qiData.expcetedClosureOn), id: 'qi-expected-closure-on-validation' },
      { condition: (!qiData.shortDescription), id: 'qi-short-description-validation' },
    ]

    const invalidIds = validations.filter((validation) => validation.condition).map((validation) => validation.id);

    if (invalidIds.length > 0) {
      this.mandatoryValidation(invalidIds);
      this.visibleMandatoryPopup = this.dialog.open(this.mandatoryPopup, this.mandatoryPopupConfig);
      this.isProcessing = false;
    } else {

      let qiObj = {

        groupId: this.selectedGroupValue[0].valueExp,
        shortDescription: qiData.shortDescription,
        description: qiData.description,
        qiType: this.selectedQiType ?? null,
        deptCode: this.selectedQiDepartment ?? null,
        requestedAt: this.selectedQiRequestedAtValue ?? null,
        coreBusinessAreaName: this.isBusinessAreaEmpty ? this.selectedQiCoreBusinessAreaNameValue : this.selectedQiCoreBusinessAreaNameValue?.join(','),
        reference: this.selectedQiReference ?? null,
        referenceOthers: qiData.referenceOthers,
        identifiedOn: qiData.identifiedOn ? this.appService.dateZoneConvertion(new Date(qiData.identifiedOn)) : null,
        expectedToBeStartedOn: qiData.expectedToBeStartedOn ? this.appService.dateZoneConvertion(new Date(qiData.expectedToBeStartedOn)) : null,
        expcetedClosureOn: qiData.expcetedClosureOn ? this.appService.dateZoneConvertion(new Date(qiData.expcetedClosureOn)) : null,
        impactType: this.selectedQiImpactType ? this.selectedQiImpactType : null,
        impactDescription: qiData.impactDescription,
        evaluator: this.selectedQiEvaluator ?? null,
        effectivenessCheckReqd: qiData.effectivenessCheckReqd ? "Y" : "N",
        isRiskCalculationReqd: qiData.isRiskCalculationReqd ? "Y" : "N"
      }

      this.appService.createQmsQi(qiObj).subscribe({
        next: (Response: any) => {
          this.qualityService.activityId = Response.ID;
          this.message.lastmsg = Response;
          if (Response.resultType == "S") {
            if (this.flexibleComponent.flexibleFields.length) { this.flexibleComponent.save('Master', +Response.ID); }

            this.getCall();
            this.showSnackBar(Response.result, Response.resultType);
            this.isProcessing = false;
            this.visibleQiAddPopup.close();
          } else {
            this.showSnackBar(Response.result, Response.resultType);
            this.isProcessing = false;
          }

        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
  }

  closeMandatoryPopup() {
    this.visibleMandatoryPopup.close();
  }

  /* Incident */
  @ViewChild('inAddPopup', { static: true }) inAddPopup: TemplateRef<any>;
  visibleInAddPopup: MatDialogRef<TemplateRef<any>>;

  openInAddPopup() {
    this.qualityService.activityId = null;
    this.popupDataTitle.title = "Create " + this.qualityService.moduleFullName;;
    this.visibleInAddPopup = this.dialog.open(this.inAddPopup, this.addAndEditPopupConfig);
  }

  cancelInPopup() {
    this.visibleInAddPopup.close();
  }

  /* Customer Complaint */
  @ViewChild('ccAddPopup', { static: true }) ccAddPopup: TemplateRef<any>;
  visibleCcAddPopup: MatDialogRef<TemplateRef<any>>;

  openCcAddPopup() {
    this.qualityService.activityId = null;
    this.popupDataTitle.title = "Create " + this.qualityService.moduleFullName;;
    this.visibleCcAddPopup = this.dialog.open(this.ccAddPopup, this.addAndEditPopupConfig);
  }

  cancelCcPopup() {
    this.visibleCcAddPopup.close();
  }

  // oos start
  public onOosMenuSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.getCall();
      }
      setTimeout(() => this.isBothTypeSelected = this.oosTypeDropdown.length == this.oosMenuType.length)
    }
  }

  public onOostTypeSelect(event: any, item: any) {
    if (event.isUserInput)
      this.handleDropDownValidation('oost-type-validation', item);
  }

  public onOosInitiatingDepartmentSelect(event: any, item: any) {
    if (event.isUserInput)
      this.handleDropDownValidation('initiating-department-validation', item);
  }

  public onOosDepartmentSelect(event: any, item: any) {
    if (event.isUserInput)
      this.handleDropDownValidation('oos-department-validation', item);
  }

  public onOosOwnerSelect(event: any, item: any) {
    if (event.isUserInput)
      this.handleDropDownValidation('oos-owner-validation', item);
  }

  oos: any = {};
  selectedTabIndex: number = 0;
  public openoosAddPopup() {
    this.qualityService.activityId = null;
    if (this.selectedGroupValue.length == 0) {
      alert('Please select the group');
    } else {
      this.oos = {};
      this.visibleEditButton = false;
      this.visibleReasonForUpdateField = false;
      if (this.qualityService.selectedGroupDetailData?.activityClosureDays) {
        const today = new Date();
        today.setDate(today.getDate() + this.qualityService.selectedGroupDetailData.activityClosureDays);
        this.oos.expcetedClosureOn = today;
      }
      this.popupTitle = "Create OOS/OOT";
      this.visibleaddPopupforOOS = this.dialog.open(this.addAndEditOOSPopup, this.addAndEditPopupConfig);
    }
  }

  public createOos(oos: any) {
    this.isProcessing = true;

    const validations = [
      { condition: (!oos.oostType), id: 'oost-type-validation' },
      { condition: (!oos.initiatingDeptCode), id: 'initiating-department-validation' },
      { condition: (!oos.oosDeptCode), id: 'oos-department-validation' },
      { condition: (!oos.owner), id: 'oos-owner-validation' },
      { condition: (!oos.identifiedOn), id: 'oos-identified-on-validation' },
      { condition: (!oos.dateOfOccurrence), id: 'oos-occurrence-validation' },
      { condition: (!oos.expectedToBeStartedOn), id: 'oos-started-on-validation' },
      { condition: (!oos.expcetedClosureOn), id: 'oos-closure-on-validation' },
    ]

    const invalidIds = validations.filter((validation) => validation.condition).map((validation) => validation.id);

    if (invalidIds.length > 0) {
      this.mandatoryValidation(invalidIds);
      this.visibleMandatoryPopup = this.dialog.open(this.mandatoryPopup, this.mandatoryPopupConfig);
      this.isProcessing = false;
    } else {
      const obj = {
        groupId: this.selectedGroupValue[0].valueExp,
        initiatedBy: this.message.getUserId(),
        initiatingDeptCode: oos.initiatingDeptCode,
        oosDeptCode: oos.oosDeptCode,
        owner: oos.owner,
        identifiedOn: oos.identifiedOn ? this.appService.dateZoneConvertion(new Date(oos.identifiedOn)) : null,
        dateOfOccurrence: oos.dateOfOccurrence ? this.appService.dateZoneConvertion(new Date(oos.dateOfOccurrence)) : null,
        expectedToBeStartedOn: oos.expectedToBeStartedOn ? this.appService.dateZoneConvertion(new Date(oos.expectedToBeStartedOn)) : null,
        expcetedClosureOn: oos.expcetedClosureOn ? this.appService.dateZoneConvertion(new Date(oos.expcetedClosureOn)) : null,
        oostType: oos.oostType
      }
      this.execute(obj);
    }
  }

  execute(obj: any = {}) {
    this.isProcessing = true;
    this.appService.createOos(obj).subscribe({
      next: (Response: any) => {
        this.qualityService.activityId = Response.ID;
        this.message.lastmsg = Response;
        if (Response.resultType == 'S') {
          this.isProcessing = false;
          this.showSnackBar(Response.result, Response.resultType);

          if (this.flexibleComponent.flexibleFields.length) { this.flexibleComponent.save('Master', +Response.ID); }

          this.getCall();
          this.visibleaddPopupforOOS.close();
        } else {
          this.showSnackBar(Response.result, Response.resultType);
          this.isProcessing = false;
        }
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    })
  }

  cancelOOSAddAndEditFunction() {
    this.visibleaddPopupforOOS.close();
  }

  /* TEXT EDITOR */

  @ViewChild('angularEditorTextarea', { static: true }) angularEditorTextarea: TemplateRef<any>;
  visibleangularEditorTextareaPopup: MatDialogRef<TemplateRef<any>>;

  angularEditorTextareaConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  editorValue: any;
  textareaEditorTitle: string = '';
  editorName: string = '';
  openEditor(value: string) {
    this.editorValue = "";
    this.editorName = value;

    const editorTitleMapping: Record<string, any> = {
      'Change Description': this.dynamicLabel?.['CHANGE_DESCRIPTION']?.fieldName,
      'Change Justification': this.dynamicLabel?.['CHANGE_JUSTIFICATION']?.fieldName,
      'CAPA Description': this.dynamicLabel?.['CAPA_DESCRIPTION']?.fieldName,
      'Deviation Description': this.dynamicLabel?.['DV_DESCRIPTION']?.fieldName,
      'Description': this.dynamicLabel?.['DESCRIPTION']?.fieldName,
      'Impact Description': this.dynamicLabel?.['IMPACT_DESCRIPTION']?.fieldName,
    };

    this.textareaEditorTitle = editorTitleMapping[this.editorName];;

    const formattedValue = this.getModel(this.editorName);
    if (this.qualityService.moduleName === 'QI') {
      this.editorValue = this.qmsQiFieldData[formattedValue] || '';
    } else if (this.qualityService.moduleName === 'DV') {
      this.editorValue = this.qmsDvFieldData[formattedValue] || '';
    } else if (this.qualityService.moduleName === 'CAPA') {
      this.editorValue = this.qmsCapaFieldData[formattedValue] || '';
    } else if (this.qualityService.moduleName === 'CR') {
      this.editorValue = this.qmsCRData[formattedValue] || '';
    } else {
      this.editorValue = '';
    }

    this.visibleangularEditorTextareaPopup = this.dialog.open(this.angularEditorTextarea, this.angularEditorTextareaConfig);
  }

  okAngularEditorData(editorValue: any) {
    console.log(editorValue);
    const formattedTitle = this.getModel(this.editorName);

    if (this.qualityService.moduleName === 'QI') {
      this.qmsQiFieldData[formattedTitle] = this.editorValue;
    } else if (this.qualityService.moduleName === 'DV') {
      this.qmsDvFieldData[formattedTitle] = this.editorValue;
    } else if (this.qualityService.moduleName === 'CAPA') {
      this.qmsCapaFieldData[formattedTitle] = this.editorValue;
    } else if (this.qualityService.moduleName === 'CR') {
      this.qmsCRData[formattedTitle] = this.editorValue;
    } else {
      this.editorValue = '';
    }
    this.visibleangularEditorTextareaPopup.close();
  }
  cancelAngularEditorData() {
    this.visibleangularEditorTextareaPopup.close();
  }

  private getModel(value: string): any {
    value = value == 'Deviation Description' ? 'dv description' : value;
    return value.split(' ')
      .map((word: string, index: number) => index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join('');
  }

  config: EditorConfig = {
    buttons: [],
  };

  config1: EditorConfig = {
    buttons: ST_BUTTONS,
  };

  showSnackBar(message: string, type: string) {
    console.log(message + "===" + type)
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ? this.message.breadcrumbData.thirdLevel : this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }

  navigateToDetails(list: any, index: any) {
    this.qualityService.activity = {};
    this.dependencyNavigationService.clear();
    this.qualityService.isTriggeredFromDependencies = false;
    this.qualityService.cancelButtonFrom = "Activity";

    if (index == 0) {
      if (this.qualityService.moduleName == 'CR') {
        this.qualityService.refereshBreadCrumb = false;
        console.log(list.CR_NO);
        this.message.activityId = list.CR_NO;
        this.qualityService.activityId = list.CR_NO;
        this.message.breadcrumbData.fourthLevel = list.CR_ID;
        this.router.navigate(['dashboard/qmsCr']);
      } else if (this.qualityService.moduleName == 'CAPA') {
        this.message.activityId = list.CAPA_NO;
        this.qualityService.activityId = list.CAPA_NO;
        this.message.breadcrumbData.fourthLevel = list.CAPA_ID;
        this.router.navigate(['dashboard/capa']);
      } else if (this.qualityService.moduleName == 'DV') {
        this.message.activityId = list.DV_NO;
        this.qualityService.activityId = list.DV_NO;
        this.message.breadcrumbData.fourthLevel = list.DV_ID;
        this.router.navigate(['dashboard/dv']);
      } else if (this.qualityService.moduleName == 'IN') {
        this.message.activityId = list.IN_NO;
        this.qualityService.activityId = list.IN_NO;
        this.message.breadcrumbData.fourthLevel = list.IN_ID;
        this.router.navigate(['dashboard/in']);
      } else if (this.qualityService.moduleName == 'QI') {
        this.message.activityId = list.QI_NO;
        this.qualityService.activityId = list.QI_NO;
        this.message.breadcrumbData.fourthLevel = list.QI_ID;
        this.router.navigate(['dashboard/qi']);
      } else if (this.qualityService.moduleName == 'CC') {
        this.message.activityId = list.CC_NO;
        this.qualityService.activityId = list.CC_NO;
        this.message.breadcrumbData.fourthLevel = list.CC_ID;
        this.router.navigate(['dashboard/cc']);
      } else if (this.qualityService.moduleName == 'OOS') {
        this.qualityService.refereshBreadCrumb = false;
        console.log(list.OOS_NO);
        this.message.activityId = list.OOS_NO;
        this.qualityService.activityId = list.OOS_NO;
        this.message.breadcrumbData.fourthLevel = list.OOS_ID;
        this.router.navigate(['dashboard/qmsOOS']);
      }
    }
  }

  selectedColumns: any = [];
  reportObj: any = {};
  columnList: any;
  dropDownForPdfColumn: any;
  isForExcel: boolean = false;
  @ViewChild('excelPdfPopup', { static: true }) excelPdfPopup: TemplateRef<any>;
  visibleExcelPdfPopup: MatDialogRef<TemplateRef<any>>;

  excelPdfPopupConfig = {
    width: '700px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  }

  openReportPopup(item: any) {
    this.pdfPageSizes = JSON.parse(sessionStorage.getItem('pdfPageSizes') || '{}');
    this.pdfPageSize = 'A4';
    this.dropDownForPdfColumn = this.columnLists?.fieldColumnarray?.map((item1: any) => ({ valueExp: item1.fieldColumnarray, displayExp: item1.fieldColumnarray }));
    [this.isAllColumns, this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, false, []];
    this.isForExcel = item == 'Excel';
    this.popupDataTitle.title = item == 'Excel' ? 'Excel Report' : 'PDF Report';
    const firstLevel = this.message.breadcrumbData.firstLevel;
    const secondLevel = this.message.breadcrumbData.secondLevel;
    const thirdLevel = this.message.breadcrumbData.thirdLevel;
    const fourthLevel = this.message.breadcrumbData.fourthLevel;

    let fileName = "";
    let after2ndSplit = [];

    if (firstLevel != null) { fileName = firstLevel + "_"; }

    if (secondLevel != null) {
      after2ndSplit = secondLevel.split(">"); for (const element of after2ndSplit) {
        fileName = fileName + element + "_";
      }
    }
    if (thirdLevel != null) { fileName = fileName + thirdLevel + "_"; }
    if (fourthLevel != null) { fileName = fileName + fourthLevel + "_"; }
    this.reportName = fileName + Date.now();
    this.selectBoxForFooter();
    this.visibleExcelPdfPopup = this.dialog.open(this.excelPdfPopup, this.excelPdfPopupConfig);
    this.isSaveReport = false;
  }

  cancelReportPopup() {
    this.visibleExcelPdfPopup.close();
    [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
  }
  limitCharacters(event: Event, field: any) {
    const target = event.target as HTMLInputElement | HTMLTextAreaElement;
    const textLength = target.value.length;
    let charLimit: any = null;

    const fieldMapping: Record<number, string[]> = {
      1000: ['REASON_FOR_CHANGE', 'REQUESTED_AT']
    };

    for (const [limit, fields] of Object.entries(fieldMapping)) {
      if (fields.includes(field)) {
        charLimit = limit;
        break;
      }
    }

    if (textLength > charLimit) {
      this.showSnackBar("Maximum " + charLimit + " Characters!", 'E');
      target.value = target.value.substring(0, charLimit);
    }
  }
  manuallyPicked: boolean;
  pdfPageSizes: any = [];
  pdfPageSize: string = "";
  onCheckboxChange(event: MatSlideToggleChange) {
    if (!event.checked) {
      [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    }
  }

  maxCountReached: boolean = false;
  selectedColumnsAsString: string = "";

  @ViewChild('columns') columns: MatSelect;
  isAllColumns = false;
  onColumnSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
        this.isAllColumns = this.selectedColumns.length == this.dropDownForPdfColumn.length;
      });
    }
  }

  onSelect() {
    if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
    this.convertArrayToString(this.selectedColumns);
  }

  onDeSelect() {
    this.onSelect();
  }

  onSelectAll(item: any[]) {
    if (item.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
    this.convertArrayToString(item);
  }

  onDeSelectAll(item: any[]) {
    if (item.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
    this.convertArrayToString(item);
  }

  convertArrayToString(array: any) {
    this.selectedColumnsAsString = array.join(', ');
  }

  generateReport(value: any) {
    if (value == 'Pdf' && this.manuallyPicked && !this.selectedColumns.length) {
      alert('Please select the Columns');
    } else if (value == 'Pdf' && this.manuallyPicked && this.selectedColumns.length > 12) {
      alert('Selected columns exceeded the limit. Limit 12, Selected ' + this.selectedColumns.length);
    } else {
      const firstLevel = this.message.breadcrumbData.firstLevel;
      const secondLevel = this.message.breadcrumbData.secondLevel;
      const thirdLevel = this.message.breadcrumbData.thirdLevel;
      const fourthLevel = this.message.breadcrumbData.fourthLevel;
      let fileName = "";
      let after2ndSplit = [];

      if (firstLevel != null) { fileName = firstLevel + "_"; }
      if (secondLevel != null) {
        after2ndSplit = secondLevel.split(">");
        for (const element of after2ndSplit) {
          fileName = fileName + element + "_";
        }
      }

      if (thirdLevel != null) { fileName = fileName + thirdLevel + "_"; }

      if (fourthLevel != null) { fileName = fileName + fourthLevel + "_"; }

      this.executeReport(value, after2ndSplit, fileName);
    }
  }

  executeReport(value: any, after2ndSplit: any, fileName: any) {
    if (value == 'Excel') {
      const pdfData = {
        ...this.reportObj, title: after2ndSplit.length > 0 ? after2ndSplit[0] : "Change Request", columns: [],
        "informationTab": {
          "Report Name": after2ndSplit.length > 0 ? after2ndSplit[0] : "Change Request",
          "Exported By": localStorage.getItem("loggedUserName")
        }
      }
      this.downloadExcelReport(pdfData, fileName + ".xlsx");

    } else {
      const pdfData = {
        ...this.reportObj,
        "logoId": this.selectedReportLogoValue ?? null,
        "isSaveRep": this.isSaveReport ? 'Y' : 'N',
        "footer": this.selectedReportFooter ?? null,
        "reportName": this.reportName ?? "QI_Report",
        "currentStatus": "NA",
        "groupName": "", title: "Report", columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.dropDownForPdfColumn.slice(0, 10).map((column: any) => column.displayExp).join(','), pdfPageSize: this.pdfPageSize
      }
      this.downloadPdfReport(pdfData, fileName + ".pdf");
    }
  }

  ctrlPressed: boolean = false;
  shiftPressed: boolean = false;
  ngOnDestroy() {
    document.removeEventListener('keydown', this.boundKeyDown);
    document.removeEventListener('keyup', this.boundKeyUp);
    window.removeEventListener('blur', this.boundReset);
    document.removeEventListener('contextmenu', this.boundReset);
    if (this.clickListener) {
      this.clickListener();
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = true;
    } else if (event.key === 'Shift') {
      this.shiftPressed = true;
    }
  }

  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = false;
    } else if (event.key === 'Shift') {
      this.shiftPressed = false;
    }
  }

  resetKeyState() {
    this.ctrlPressed = false;
    this.shiftPressed = false;
  }

  onPaste(event: ClipboardEvent) {
    const isAllowedPaste = this.ctrlPressed && this.shiftPressed;
    if (!isAllowedPaste) {
      event.preventDefault();
      this.showSnackBar("You can't perform this operation. Please use Ctrl + Shift + V to paste the content", 'E');
    }
  }

  @ViewChild('qiBusinessArea') qiBusinessArea: MatSelect;
  isAllQIBusinessAreaSelected = false;

  @ViewChild('oosMenu') oosMenu: MatSelect;
  isBothTypeSelected = false;
  oosMenuType: any = [];

  toggleAllSelection(value: any) {
    if (value == 'qiBusinessArea') {
      if (this.isAllQIBusinessAreaSelected) this.qiBusinessArea.options.forEach((item: MatOption) => item.select());
      else {
        this.qiBusinessArea.options.forEach((item: MatOption) => item.deselect())
        this.selectedQiCoreBusinessAreaNameValue = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation('qi-corebusiness-area-validation', this.selectedQiCoreBusinessAreaNameValue)
      });
    }
    if (value == 'oosMenu') {
      if (this.isBothTypeSelected) this.oosMenu.options.forEach((item: MatOption) => item.select());
      else {
        this.oosMenu.options.forEach((item: MatOption) => item.deselect());
        this.oosMenuType = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation('qi-corebusiness-area-validation', this.selectedQiCoreBusinessAreaNameValue);
        this.getCall();
      });
    }
    if (value == 'columns') {
      if (this.isAllColumns) this.columns.options.forEach((item: MatOption) => item.select());
      else {
        this.columns.options.forEach((item: MatOption) => item.deselect())
        this.selectedColumns = [];
      }
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
      });
    }
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openreorder() {
    this.gridReorderComponent.reordercall(this.qualityService.moduleName, this.tableName, this.qualityService.moduleName, this.qualityService.selectedGroup)
  }

  onChildValueEmitted() {
    this.getCall();
  };

  downloadExcelReport(data: any, fileName: string) {
    this.isProcessing = true;
    this.appService.downloadexcel(data).subscribe({
      next: (response: any) => {
        let dataType = response.type;
        let binaryData = [];
        binaryData.push(response);
        let downloadLink = document.createElement('a');
        downloadLink.href = globalThis.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
        if (fileName)
          downloadLink.setAttribute('download', fileName);
        document.body.appendChild(downloadLink);
        downloadLink.click();
        this.isProcessing = false;
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  downloadPdfReport(pdfData: any, fileName: string) {
    this.isProcessing = true;
    this.appService.downloadPdf(pdfData).subscribe({
      next: (response: any) => {
        let dataType = response.type;
        let binaryData = [];
        binaryData.push(response);
        let downloadLink = document.createElement('a');
        downloadLink.href = globalThis.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
        if (fileName)
          downloadLink.setAttribute('download', fileName);
        document.body.appendChild(downloadLink);
        downloadLink.click();
        this.isProcessing = false;
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }


  ngAfterViewInit() {
    /* Listener for document click */
    this.clickListener = this.renderer.listen('document', 'click', () => {
      if (this.snackbarRef) {
        this.snackbarRef.dismiss();
      }
    });
  }

  @ViewChild(ActivityAuTrailComponent) activityAuTrailComponent!: ActivityAuTrailComponent;
  openAuditTrail(activity: any) {
    this.activityAuTrailComponent.openAuditTrail(activity);
  }

  dropDownDataForReportLogo: any;
  selectedReportLogoValue: any = null;
  reportLogoFieldValidation: any;
  reportFooterFieldValidation: any;
  reportLogoDropdown: any = [];
  imageIdList: any = [];
  organizationReportImageDetails: any = {};
  logoVals: any;
  isSaveReport: boolean = false;
  reportName: any;
  pdfDetailSearchText: string = '';
  onReportLogoValueSelect(event: any, item: any) {
    if (event.isUserInput) {

      if (this.reportLogoFieldValidation != undefined) {
        this.reportLogoFieldValidation.style.color = '#005c8a';
      }
    }
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  selectBoxForReportLogo() {
    this.reportLogoDropdown = [];
    if (this.dropDownDataForReportLogo) {
      if (this.dropDownDataForReportLogo.reportImageList == 'Default') {
        this.reportLogoDropdown = this.reportLogoDropdown.concat({
          valueExp: 0,
          displayExp: 'Default'
        });
      } else if (this.dropDownDataForReportLogo.reportImageList.includes(",")) {
        this.imageIdList = this.dropDownDataForReportLogo.reportImageList.split(",");
        for (let i = 0; i < this.imageIdList.length; i++) {
          if (i == 0 && this.imageIdList[i] == 'Default') {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: 0,
              displayExp: 'Default'
            });
          } else {
            for (const element of this.organizationReportImageDetails) {
              if (element.reportImageId == this.imageIdList[i]) {
                this.reportLogoDropdown = this.reportLogoDropdown.concat({
                  valueExp: element.reportImageId,
                  displayExp: element.reportImageName
                });
              }

            }
          }
        }
      } else {
        for (const element of this.organizationReportImageDetails) {
          if (element.reportImageId == this.dropDownDataForReportLogo.reportImageList) {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: element.reportImageId,
              displayExp: element.reportImageName
            });
          }
        }
      }
      if (this.dropDownDataForReportLogo.defaultReportName != 'Default' && this.dropDownDataForReportLogo.defaultReportName != null) {
        for (const element of this.reportLogoDropdown) {
          if (element.valueExp == this.dropDownDataForReportLogo.defaultReportName) {
            this.selectedReportLogoValue = element.valueExp;
          }
        }
      } else {
        this.selectedReportLogoValue = this.reportLogoDropdown[0].valueExp;
      }
    } else {
      this.selectedReportLogoValue = [];
    }
  }

  onReportFooterSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.reportFooterFieldValidation != undefined) {
        this.reportFooterFieldValidation.style.color = '#005c8a';
      }
    }
  }

  ngOnChangesReportFooter() {
    this.isProcessing = true;
    this.appService.getCodeListsByGroup("REPORT_FOOTER").subscribe({
      next: (data: any) => {
        this.reportFooterDropdown1 = data;
        this.selectBoxForFooter();
        if (this.reportFooterDropdown.length > 0) {
          this.selectedReportFooter = this.reportFooterDropdown[0].displayExp;
        }
        this.isProcessing = false;
      },
      error: (error: any) => {
        this.isProcessing = false;
      }
    });
  }

  selectBoxForFooter() {
    this.reportFooterDropdown = [];
    for (const vals of this.reportFooterDropdown1) {
      if (vals.moduleList == "Common" || vals.moduleList.includes(this.qualityService.moduleName)) {
        this.reportFooterDropdown.push({
          valueExp: vals.codelistName,
          displayExp: vals.codelistName
        });
      }
    }
  }

  getToolTip(x: any): any {
    if (x === 'htmlClobView') {
      return '';
    }

    if (typeof x === 'boolean') {
      return x ? 'Yes' : 'No';
    }

    return x;
  }

  focusEmpty() {
    console.log();
  }

}
